<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1 position-relative">

    <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeOrderSummaryDialog()"
            class="close-icon d-flex align-items-center justify-content-center zx-z-index-2"
            [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- lottie -->
    <div class="w-100 justify-content-center align-items-end position-absolute top-0 zx-z-index-2 zx-successfully-lottie-con"
        [class.d-none]="!(isLottieStart && !isLottieEnd)" [class.d-flex]="isLottieStart && !isLottieEnd"
        [class.zx-opacity-trans-lottie]="isLottieMiddle && !isLottieEnd">
        <div class="zx-successfully-lottie" id="animationContainer"></div>
    </div>
    <!-- lottie -->

    <!-- TO APROVE ===================================== TO APROVE ===================================== TO APROVE  -->
    <div *ngIf="(!isOrderAproved && (!isLoading && !isOrderPrinted && !isOrderSaved) && isThumbnailsOK) && !isPH"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-lg-2 w-100 position-relative"
        [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <article class="d-flex w-100 position-absolute top-0 p-2 p-lg-3 pt-lg-4" [class.justify-content-end]="!isRTL">
            <h6 class="zx-text-big fw-bold px-2 pt-2" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
                {{ "order-summary-title" | translate }}
            </h6>
        </article>

        <!-- explanation -->
        <div class="w-100 d-flex flex-column max-w-explanation pt-4">
            <div class="d-flex align-items-center gap-2 py-2 pt-lg-0" [class.zx-text-white]="isDarkMode"
                [class.flex-row-reverse]="!isRTL">
                <img [src]="'assets/images/' + getPrintingService(printingService) + '-icon.svg'"
                    alt="choosen printing system icon" class="zx-small-small-plus-icon-size">
                <img [src]="'assets/images/branches/' + branchName + '.png'" alt="choosen printing system icon"
                    class="zx-small-small-plus-icon-size c-pointer">
                <b class="zx-text-small">
                    {{ "choose-branch.naming." + printingService + "." + branchName | translate }}
                </b>
            </div>
            <p class="m-0 pb-2 zx-text-medium w-100 py-2 opacity-75 d-flex" [class.text-white]="isDarkMode"
                [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                {{ "order-summary-explanation" | translate }}
            </p>
        </div>

        <!-- files [plotter] ---------- files [plotter] ---------- files [plotter]  -->
        <div *ngIf="printingService === 'plotter' && files && files.length > 0"
            class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">
                <!-- file -->
                <section
                    ngClass="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2 gap-md-0"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    *ngFor="let file of files; index as i" class="d-flex w-100">
                    <!-- name - multi page -->
                    <span *ngIf="file.images.length > 1"
                        class="zx-text-small zx-text-pink col-12 w-100 p-0 pb-lg-2 px-lg-2" [class.text-start]="!isRTL"
                        [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                        <span class="d-sm-none">
                            <span>
                                {{getDisplayFileNameAfterSplit(file) | slice:0:17}}
                            </span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">
                                ...
                            </span>
                            <span class="zx-100-opacity">--</span>
                            <span class="fw-normal zx-text-tiny text-green">
                                <span>(</span>
                                <span>
                                    {{ file.images.length }}
                                </span>
                                <span class="zx-text-tiny-tiny">
                                    {{ "printing-table.pages-short" | translate }}
                                </span>
                                <span>)</span>
                            </span>
                        </span>
                        <span class="d-none d-sm-flex">
                            <span>
                                {{getDisplayFileNameAfterSplit(file) | slice:0:40}}
                            </span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">
                                ...
                            </span>
                            <span class="zx-100-opacity">--</span>
                            <span class="fw-normal text-green">
                                <span>(</span>
                                <span>
                                    {{ file.images.length }}
                                </span>
                                <span class="zx-text-tiny">
                                    {{ "printing-table.pages-short" | translate }}
                                </span>
                                <span>)</span>
                            </span>
                        </span>
                    </span>
                    <!-- 1st line -->
                    <article *ngFor="let image of file.images; index as j"
                        class="d-flex align-items-center gap-2 gap-lg-3 p-0"
                        [class.zx-border-gray-top-25-pr]="file.images.length > 1"
                        [class.zx-border-gray-left-25-pr-md]="j % 2 === 0 && file.images.length > 1"
                        [class.flex-row-reverse]="!isRTL" [class.col-12]="file.images.length === 1"
                        [class.py-1]="file.images.length > 1" [class.py-lg-2]="file.images.length > 1"
                        [class.ps-md-2]="file.images.length > 1 && j % 2 === 0"
                        [class.pe-md-2]="file.images.length > 1 && j % 2 !== 0" [class.col-12]="file.images.length > 1"
                        [class.col-md-6]="file.images.length > 1">
                        <!-- image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img class="w-100 h-100 object-fit-contain" [src]="getImgPlotter(image)"
                                    alt="File Page Image">
                            </div>
                            <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                                    <span>{{ getSizePlotter(image.height) }}</span>
                                    <span> × </span>
                                    <span>{{ getSizePlotter(image.width) }}</span>
                                    <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                    </span>
                                </span>
                            </div>
                            <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0">
                                <span class="p-1 p-lg-2 zx-bg-light">
                                    <div class="d-flex align-items-center text-green zx-text-tiny"
                                        [class.flex-row-reverse]="isRTL">
                                        <span>
                                            {{j + 1}}
                                        </span>
                                        <span>/</span>
                                        <span>
                                            {{file.images.length}}
                                        </span>
                                    </div>
                                </span>
                            </article>
                        </article>

                        <!-- file date -->
                        <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                            <!-- [up container] - for more then 1 copy in 1 image files -->
                            <div class="d-flex d-sm-none w-100"
                                *ngIf="file.images.length === 1 && image.settings.numOfCopies > 1"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- name - single page -->
                                <span class="zx-text-small zx-text-pink" [class.zx-ltr]="!isRTL"
                                    [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                                    <span class="d-sm-none" [class.zx-ltr]="!isRTL">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:12}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 12">
                                            ...
                                        </span>
                                    </span>
                                    <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:30}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 30">
                                            ...
                                        </span>
                                    </span>
                                </span>
                            </div>

                            <!-- [up container] -->
                            <div class="d-flex w-100 justify-content-between align-items-center"
                                [class.pb-1]="file.images.length === 1" [class.flex-row-reverse]="!isRTL">
                                <!-- name placeholder - milti page -->
                                <span *ngIf="file.images.length > 1" class="zx-100-opacity">-</span>
                                <!-- name - single page -->
                                <span *ngIf="file.images.length === 1 " class="zx-text-small zx-text-pink"
                                    [class.zx-ltr]="!isRTL" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span *ngIf="image.settings.numOfCopies === 1" class="d-sm-none"
                                        [class.zx-ltr]="!isRTL">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:12}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 12">
                                            ...
                                        </span>
                                    </span>
                                    <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:30}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 30">
                                            ...
                                        </span>
                                    </span>
                                </span>
                                <!-- total file price -->
                                <span class="px-1 px-lg-3 zx-min-w-price" [class.fw-bold]="!isDarkMode"
                                    [class.zx-ltr]="!isRTL" [class.zx-text-white]="isDarkMode">
                                    <span *ngIf="image.settings.numOfCopies > 1" class="zx-text-tiny fw-normal"
                                        [class.zx-ltr]="!isRTL">
                                        <span>
                                            {{
                                            roundDownTowDecimal(
                                            image.price
                                            ) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.nis" | translate }}
                                        </span>
                                        <span>×</span>
                                        <span>
                                            {{ image.settings.numOfCopies }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.copies-short" | translate }}
                                        </span>
                                        <span>=</span>
                                    </span>
                                    <span class="zx-text-small">
                                        {{
                                        roundDownTowDecimal(
                                        image.settings.numOfCopies *
                                        image.price
                                        )
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </div>

                            <!-- [settings] -->
                            <div class="d-flex flex-column gap-1 gap-lg-2" (click)="explainHowToChaingeSettings()">
                                <!-- paper & bw & resize -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- paper -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            {{ 'paper-type.name-short.' + image.paperSerialName | translate }}
                                        </b>
                                    </div>
                                    <!-- bw -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.settings.bw">
                                                {{ "printing-table.color-color" | translate }}
                                            </span>
                                            <span *ngIf="image.settings.bw">
                                                {{ "printing-table.color-bandw" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- resize -->
                                    <div *ngIf="file.images.length === 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode"
                                            [class.zx-ltr]="!isRTL">
                                            <span *ngIf="image.resizeFactor > 100">
                                                {{ "order-summary-resize-bigger" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor < 100">
                                                {{ "order-summary-resize-smaller" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor === 100">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor !== 100" [class.zx-ltr]="!isRTL">
                                                <span *ngIf="isRTL">%</span>
                                                <span>
                                                    {{
                                                    image.resizeFactor
                                                    }}
                                                </span>
                                                <span *ngIf="!isRTL">%</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <!-- center & borders -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- center -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.settings.centered">
                                                {{ "order-summary-not-centered" | translate }}
                                            </span>
                                            <span *ngIf="image.settings.centered">
                                                {{ "order-summary-is-centered" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- borders -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.settings.cmFromTop">
                                                {{ "order-summary-not-borders" | translate }}
                                            </span>
                                            <span *ngIf="image.settings.cmFromTop">
                                                {{ "order-summary-is-borders" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <!-- resize -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <div *ngIf="file.images.length > 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode"
                                            [class.zx-ltr]="!isRTL">
                                            <span *ngIf="image.resizeFactor > 100">
                                                {{ "order-summary-resize-bigger" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor < 100">
                                                {{ "order-summary-resize-smaller" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor === 100">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor !== 100">
                                                <span *ngIf="isRTL">%</span>
                                                <span>
                                                    {{
                                                    image.resizeFactor
                                                    }}
                                                </span>
                                                <span *ngIf="!isRTL">%</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </article>
                        <!-- // file date -->
                    </article>
                    <!-- // 1st line -->
                </section>
            </div>
        </div>

        <!-- files [express] ---------- files [express] ---------- files [express]  -->
        <div *ngIf="printingService === 'express'" class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">

                <!-- products -->
                <section ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    *ngFor="let product of fixProductsArray; index as i" class="d-flex w-100">
                    <!-- 1st line -->
                    <article class="d-flex gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
                        <!-- product image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img class="w-100 h-100 object-fit-contain"
                                    [src]="'assets/images/fix-products/' + product.productId.previewImage + '.png'"
                                    alt="File Page Image">
                            </div>
                        </article>
                        <!-- product date -->
                        <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                            <!-- [up container] -->
                            <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- name -->
                                <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span>
                                        {{ "fix-product." + product.productId.name | translate }}
                                    </span>
                                </span>
                                <!-- total file price -->
                                <span class="px-1 px-lg-3 zx-min-w-price" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span class="zx-text-small">
                                        {{
                                        roundDownTowDecimal(
                                        product.productId.defaultPrice *
                                        product.numOfCopies
                                        )
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </div>

                            <!-- calc file price -->
                            <span [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode"
                                [class.zx-ltr]="!isRTL">
                                <span class="px-1" *ngIf="product.numOfCopies > 1">
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        product.numOfCopies
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "su-management.units.short" | translate }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "fix-products.price" | translate }}
                                    </span>
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        product.productId.defaultPrice
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </span>

                        </article>
                        <!-- // file date -->
                    </article>
                    <!-- // 1st line -->

                    <!-- 2nd line -->

                    <!-- // 2nd line -->
                </section>
                <!-- // fix products -->

                <!-- files -->
                <section ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    *ngFor="let file of files; index as i" class="d-flex w-100">
                    <!-- 1st line -->
                    <article class="d-flex align-items-center gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
                        <!-- first image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img class="w-100 h-100 object-fit-contain" [src]="file.images[0].path"
                                    alt="File Page Image">
                            </div>
                            <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                                    <span>{{ file.images[0].height }}</span>
                                    <span>×</span>
                                    <span>{{ file.images[0].width }}</span>
                                    <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                    </span>
                                </span>
                            </div>
                            <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0"
                                [class.flex-row-reverse]="!isRTL">
                                <span class="p-1 p-lg-2 zx-bg-light">
                                    <div class="d-flex align-items-center text-green zx-text-tiny"
                                        [class.flex-row-reverse]="isRTL">
                                        <span>1</span>
                                        <span>/</span>
                                        <span>
                                            {{file.images.length}}
                                        </span>
                                    </div>
                                </span>
                            </article>
                        </article>
                        <!-- file date -->
                        <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                            <!-- [up container] -->
                            <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- name -->
                                <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span class="d-sm-none">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:17}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">
                                            ...
                                        </span>
                                    </span>
                                    <span class="d-none d-sm-flex">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:40}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">
                                            ...
                                        </span>
                                    </span>
                                </span>
                                <!-- total file price -->
                                <span class="px-1 px-lg-3 zx-min-w-price" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span class="zx-text-small">
                                        {{
                                        roundDownTowDecimal(
                                        file.price.copies *
                                        file.price.pages *
                                        file.price.pricePerPage)
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </div>

                            <!-- [settings] -->
                            <div class="d-flex flex-column gap-1 gap-lg-2" [class.flex-sm-row]="isRTL"
                                (click)="explainHowToChaingeSettings()" [class.flex-sm-row-reverse]="!isRTL">
                                <!-- paper & bw -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- paper -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            {{ 'paper-type.name-short.' + file.paperSerialName | translate }}
                                        </b>
                                    </div>
                                    <!-- bw -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <span *ngIf="!file.settings.bw">
                                                {{ "printing-table.color-color" | translate }}
                                            </span>
                                            <span *ngIf="file.settings.bw">
                                                {{ "printing-table.color-bandw" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <!-- doubleSided & fit -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- doubleSided -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <span *ngIf="!file.settings.doubleSided">
                                                {{ "printing-table.sides-one" | translate }}
                                            </span>
                                            <span *ngIf="file.settings.doubleSided">
                                                {{ "printing-table.sides-two" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- fit -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <!-- <span *ngIf="!file.settings.fit">
                                                {{ "printing-table.size-original" | translate }}
                                            </span>
                                            <span *ngIf="file.settings.fit">
                                                {{ "printing-table.size-maximal" | translate }}
                                            </span> -->
                                            <span *ngIf="!file.settings.fit && !file.settings.cropRatio">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="file.settings.fit && !file.settings.cropRatio">
                                                {{ "order-summary-resize-maximal" | translate }}
                                            </span>
                                            <span *ngIf="file.settings.cropRatio">
                                                {{ "order-summary-resize-crop" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- [down container] -->
                            <!-- calc file price -->
                            <span [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode"
                                [class.zx-ltr]="!isRTL">
                                <!-- pages -->
                                <span *ngIf="file.price.pages > 1">
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        file.price.pages
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.pages-short" | translate }}
                                    </span>
                                </span>
                                <!-- , -->
                                <span *ngIf="file.price.pages > 1 && file.price.copies > 1">
                                    <!-- <span class="zx-100-opacity">_</span> -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                </span>
                                <span *ngIf="file.price.copies > 1">
                                    <!-- copies -->
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        file.price.copies
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.copies-short" | translate }}
                                    </span>
                                    <!-- , -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                    <!-- price per page -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.price-per-copy" | translate }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">:</span>
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        roundDownTowDecimal(
                                        file.price.pricePerPage *
                                        file.price.pages)
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </span>

                        </article>
                        <!-- // file date -->
                    </article>
                    <!-- // 1st line -->

                    <!-- 2nd line -->
                    <article *ngIf="file.images.length > 1" class="d-flex row w-100 pt-1" [class.zx-ltr]="!isRTL">
                        <article *ngFor="let image of file.images; let j = index" [class.d-flex]="j !== 0"
                            [class.d-none]="j === 0" class="col-4 col-sm-3 col-md-2 pb-1">
                            <!-- 2 + image -->
                            <article
                                class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                                <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                    <img class="w-100 h-100 object-fit-contain" [src]="file.images[j].path"
                                        alt="File Page Image">
                                </div>
                                <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                    <span class="zx-text-tiny">
                                        <span>{{file.images[j].height}}</span>
                                        <span>×</span>
                                        <span>{{file.images[j].width}}</span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </span>
                                </div>
                                <article class="position-absolute d-flex w-100 top-0">
                                    <span class="p-1 p-lg-2 zx-bg-light">
                                        <div class="d-flex align-items-center text-green zx-text-tiny"
                                            [class.flex-row-reverse]="isRTL">
                                            <span>
                                                {{j + 1}}
                                            </span>
                                            <span>/</span>
                                            <span>
                                                {{file.images.length}}
                                            </span>
                                        </div>
                                    </span>
                                </article>
                            </article>
                            <!-- // 2 + image -->
                        </article>
                    </article>
                    <!-- // 2nd line -->
                </section>
                <!-- // files -->

            </div>
        </div>
        <!-- // files [express] -->

        <!-- files and price TOTAL line -->
        <section class="d-flex flex-column align-items-end w-100 pt-1 gap-1">
            <!-- total price -->
            <div class="w-100 px-3 py-2 d-flex justify-content-between align-items-center" [class.zx-ltr]="!isRTL">

                <!-- title and files + isMnigerOrder -->
                <div
                    class="d-flex flex-column flex-lg-row align-items-start align-items-lg-end gap-lg-2 flex-grow-1 justify-content-between">
                    <!-- title and files -->
                    <span class="d-flex gap-2"
                        [class.flex-column]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                        [class.flex-sm-row]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && isRTL"
                        [class.flex-sm-row-reverse]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && !isRTL"
                        [class.align-items-sm-end]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                        [class.align-items-end]="!(totalPriceData && totalPriceData.points && totalPriceData.points > 0)">
                        <span class="zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.total-price' | translate }}
                        </span>
                        <span>
                            <span [class.text-white]="isDarkMode">
                                <span *ngIf="files && files.length > 1">
                                    <b class="zx-text-small">
                                        {{ files.length }}
                                    </b>
                                    <b class="zx-text-small">
                                        {{ 'printing-table.files' | translate }}
                                    </b>
                                </span>
                                <b class="zx-text-small" *ngIf="files && files.length === 1">
                                    {{ 'printing-table.one-file' | translate }}
                                </b>
                            </span>
                            <span
                                *ngIf="totalPriceData.fixProductsTotalPrice > 0 && totalPriceData.totalOrderPrice > 0">
                                <span>,</span>
                                <span class="zx-100-opp">-</span>
                            </span>
                            <span *ngIf="totalPriceData.fixProductsTotalPrice > 0" [class.text-white]="isDarkMode">
                                <span *ngIf="getAmountOfFixProducts(fixProductsArray) > 1">
                                    <b class="zx-text-small">
                                        {{ getAmountOfFixProducts(fixProductsArray) }}
                                    </b>
                                    <b class="zx-text-small">
                                        {{ 'fix-products.num-of-products.many' | translate }}
                                    </b>
                                </span>
                                <b class="zx-text-small" *ngIf="getAmountOfFixProducts(fixProductsArray) === 1">
                                    {{ 'fix-products.num-of-products.one' | translate }}
                                </b>
                            </span>
                        </span>
                    </span>

                    <!-- isAdminOrder ? -->
                    <span *ngIf="isAdminOrder" class="zx-text-tiny-tiny pb-lg-1 px-lg-2" [class.text-white]="isDarkMode"
                        [class.zx-text-pink]="!isDarkMode">
                        <b>
                            ·
                        </b>
                        <span>
                            {{ "my-orders.manager-order" | translate }}
                        </span>
                        <b>
                            ·
                        </b>
                    </span>
                </div>
                <!-- // title and files + isMnigerOrder -->

                <!-- pricing calc -->
                <span class="d-flex align-items-end gap-1 gap-lg-2"
                    [class.flex-column]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                    [class.flex-sm-row]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && isRTL"
                    [class.flex-sm-row-reverse]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && !isRTL"
                    [class.zx-text-white]="isDarkMode">
                    <!-- before discount price -->
                    <span [class.zx-ltr]="!isRTL">
                        <span class="opacity-75 zx-text-tiny" [class.zx-ltr]="!isRTL" *ngIf="!((totalPriceData.totalOrderPrice - totalPriceData.totalOrderPriceBeforeDiscount < 0.05) &&
                        (totalPriceData.totalOrderPrice - totalPriceData.totalOrderPriceBeforeDiscount > -0.05)) &&
                             totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0">
                            <span class="strikethrough">
                                <span>
                                    {{ roundDownTowDecimal(totalPriceData.totalOrderPriceBeforeDiscount +
                                    totalPriceData.fixProductsTotalPrice) }}
                                </span>
                                <span>
                                    {{ 'printing-table.nis' | translate }}
                                </span>
                            </span>
                            <span class="zx-100-opacity">.</span>
                        </span>
                        <!-- total price if have points -->
                        <span class="zx-text-small" [class.zx-ltr]="!isRTL"
                            *ngIf="totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0 && totalPriceData.points >= 0.1">
                            <span>
                                {{ roundDownTowDecimal(totalPriceData.totalOrderPrice +
                                totalPriceData.fixProductsTotalPrice) }}
                            </span>
                            <span class="zx-text-tiny-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </span>
                            <span>:</span>
                        </span>
                    </span>
                    <span>
                        <!-- real price (after discount) -->
                        <span *ngIf="(totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0) ||
                            totalPriceData.fixProductsTotalPrice > 0">
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal( totalPriceData.totalOrderPrice - totalPriceData.points +
                                totalPriceData.fixProductsTotalPrice) :
                                totalPriceData.fixProductsTotalPrice }}
                            </b>
                            <b class="zx-text-tiny-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </b>
                        </span>
                        <!-- if have EAZIX points -->
                        <span
                            *ngIf="totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0 && totalPriceData.points >= 0.1">
                            <span class="zx-text-tiny-tiny">+</span>
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal(totalPriceData.points) :
                                roundDownTowDecimal(totalPriceData.totalOrderPrice) }}
                            </b>
                            <b class="zx-text-tiny-tiny">
                                {{ 'printing-table.points-short' | translate }}
                            </b>
                        </span>
                    </span>
                </span>
            </div>

            <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
                [class.flex-row-reverse]="!isRTL">
                <button color="primary" mat-raised-button class="text-white rounded-pill w-100"
                    (click)="approveOrderSummary()">
                    <b *ngIf="!(isPendingOrder && printingService === 'plotter')">
                        {{ "order-summary-aprove" | translate }}
                    </b>
                    <b *ngIf="isPendingOrder && printingService === 'plotter'">
                        {{ "order-summary-aprove-and-print" | translate }}
                    </b>
                </button>
                <button *ngIf="!isPendingOrder" [disabled]="isLoadingAproveOrderSummary" mat-button
                    class="rounded-pill w-100 text-green fw-bold" (click)="closeOrderSummaryDialog()">
                    {{ "order-summary-edit" | translate }}
                </button>
            </div>

        </section>
        <!-- // files and price TOTAL line -->

    </div>
    <!-- // TO APROVE ===================================== TO APROVE ===================================== TO APROVE  -->
















    <!-- [PH] TO APROVE [PH] ===================================== [PH] TO APROVE [PH] ===================================== [PH] TO APROVE [PH]  -->
    <div *ngIf="(!isOrderAproved && (!isLoading && !isOrderPrinted && !isOrderSaved) && isThumbnailsOK) && isPH"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-lg-2 w-100 position-relative"
        [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <article class="d-flex w-100 position-absolute top-0 p-2 p-lg-3 pt-lg-4" [class.justify-content-end]="!isRTL">
            <h6 class="zx-text-big fw-bold px-2 pt-2" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
                {{ "order-summary-title" | translate }}
            </h6>
        </article>

        <!-- explanation -->
        <div class="w-100 d-flex flex-column max-w-explanation pt-4">
            <div class="d-flex align-items-center gap-2 py-2 pt-lg-0" [class.zx-text-white]="isDarkMode"
                [class.flex-row-reverse]="!isRTL">
                <img [src]="phOrderSummarySystemIconSrc" alt="" class="zx-small-small-plus-icon-size">
                <img [src]="'assets/images/products/' + branchName + '.svg'" alt="Fast Delivery Icon"
                    class="zx-small-small-plus-icon-size">
                <b class="zx-text-small">
                    <span>
                        {{ "choose-product.naming." + branchName | translate }}
                    </span>
                    <span>
                        {{ "choose-system.title-short-ph-in" | translate }}
                    </span>
                </b>
            </div>
            <p class="m-0 pb-2 zx-text-medium w-100 py-2 opacity-75 d-flex" [class.text-white]="isDarkMode"
                [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                {{ "order-summary-explanation" | translate }}
            </p>
        </div>

        <!-- files [ph] ---------- files [ph] ---------- files [ph]  -->
        <div class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">

                <!-- collection object - points / pickup / appointment (מעל הקבצים) -->
                <section *ngIf="isPH && collectionData.selectedCollectOption && selectedPlace && collectionData.selectedCollectOption !== 'delivery'"
                    ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL" class="d-flex w-100">
                    <div class="d-flex w-100 justify-content-between align-items-center px-2" [class.flex-row]="!isRTL">
                        <!-- UP -->
                        <span class="zx-text-small px-1 d-flex flex-column gap-1 gap-lg-2 h-100"
                            [class.zx-text-white]="isDarkMode">

                            <!-- service -->
                            <span [class.text-start]="!isRTL" [class.text-end]="isRTL">
                                {{ 'collect.' + collectionData.selectedCollectOption + '.title' | translate }}:
                            </span>

                            <!-- name -->
                            <span [class.text-start]="!isRTL" [class.text-end]="isRTL" [class.fw-bold]="!isDarkMode"
                                [class.zx-text-pink]="!isDarkMode">
                                {{ selectedPlace.translatedName }}
                            </span>

                            <!-- adress -->
                            <span class="opacity-75" *ngIf="selectedPlace?.translatedAddress"
                                [class.zx-text-pink]="!isDarkMode" [class.text-start]="!isRTL" [class.text-end]="isRTL">
                                <span>
                                    {{ "collect.in-adress" | translate }}
                                </span>
                                <span>
                                    {{ selectedPlace.translatedAddress }}
                                </span>
                            </span>

                            <!-- obligation mobile -->
                            <span class="opacity-75 d-md-none" *ngIf="selectedPlace?.translatedAddress"
                                [class.text-start]="!isRTL" [class.text-end]="isRTL">{{ getCommitmentDisplayText() }}</span>

                        </span>

                        <!-- DOWN -->
                        <span
                            class="zx-text-small px-1 d-flex flex-column align-items-end px-1 px-lg-3 zx-min-w-price gap-1 gap-lg-2 h-100"
                            [class.zx-text-white]="isDarkMode">

                            <!-- price -->
                            <span [class.fw-bold]="!isDarkMode && collectionData.selectedCollectPrice > 0">
                                <span class="zx-text-small">
                                    {{ collectionData.selectedCollectPrice > 0 ?
                                    collectionData.selectedCollectPrice :
                                    ("collect.price.none" | translate) }}
                                </span>
                                <span *ngIf="collectionData.selectedCollectPrice > 0"
                                    class="zx-text-tiny-tiny zx-text-sm-tiny">
                                    {{ "printing-table.nis" | translate }}
                                </span>
                            </span>

                            <span class="zx-100-opp">-</span>

                            <!-- obligation desktop -->
                            <span class="opacity-75 d-none d-md-block" *ngIf="selectedPlace?.translatedAddress"
                                [class.text-start]="isRTL" [class.text-end]="!isRTL">{{ getCommitmentDisplayText() }}</span>

                        </span>
                    </div>
                </section>
                <!-- collection object -->

                <!-- collection object - delivery (משלוח עד הבית) -->
                <section *ngIf="isPH && collectionData?.selectedCollectOption === 'delivery' && collectionData?.deliveryAddress"
                    ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL" class="d-flex w-100">
                    <div class="d-flex w-100 justify-content-between align-items-center px-2" [class.flex-row]="!isRTL">
                        <!-- UP - address fields -->
                        <span class="zx-text-small px-1 d-flex flex-column gap-1 gap-lg-2 h-100"
                            [class.zx-text-white]="isDarkMode">

                            <span [class.text-start]="!isRTL" [class.text-end]="isRTL">
                                {{ 'collect.delivery.title' | translate }}:
                            </span>

                            <span [class.text-start]="!isRTL" [class.text-end]="isRTL" [class.fw-bold]="!isDarkMode"
                                [class.zx-text-pink]="!isDarkMode">
                                {{ collectionData.deliveryAddress.fullAddress || (collectionData.deliveryAddress.street + (collectionData.deliveryAddress.houseNumber ? ' ' + collectionData.deliveryAddress.houseNumber : '') + (collectionData.deliveryAddress.city ? ', ' + collectionData.deliveryAddress.city : '')) }}
                            </span>

                            <span class="opacity-75 d-md-none" [class.text-start]="!isRTL" [class.text-end]="isRTL">{{ getCommitmentDisplayText() }}</span>
                        </span>

                        <!-- DOWN - price and obligation -->
                        <span
                            class="zx-text-small px-1 d-flex flex-column align-items-end px-1 px-lg-3 zx-min-w-price gap-1 gap-lg-2 h-100"
                            [class.zx-text-white]="isDarkMode">

                            <span [class.fw-bold]="!isDarkMode && collectionData.selectedCollectPrice > 0">
                                <span class="zx-text-small">
                                    {{ collectionData.selectedCollectPrice > 0 ?
                                    collectionData.selectedCollectPrice :
                                    ("collect.price.none" | translate) }}
                                </span>
                                <span *ngIf="collectionData.selectedCollectPrice > 0"
                                    class="zx-text-tiny-tiny zx-text-sm-tiny">
                                    {{ "printing-table.nis" | translate }}
                                </span>
                            </span>

                            <span class="zx-100-opp">-</span>

                            <span class="opacity-75 d-none d-md-block" [class.text-start]="isRTL" [class.text-end]="!isRTL">{{ getCommitmentDisplayText() }}</span>
                        </span>
                    </div>
                </section>
                <!-- // collection object - delivery -->

                <!-- files -->
                <ng-container *ngFor="let file of (files || []); index as i">
                <section *ngIf="file.images && file.images.length > 0"
                    ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    class="d-flex w-100">
                    <!-- 1st line -->
                    <article class="d-flex align-items-center gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
                        <!-- first image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light"
                            [class.justify-content-center]="is3D"
                            [class.justify-content-between]="!is3D">
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img class="w-100 h-100 object-fit-contain" [src]="file.images[0].path"
                                    alt="File Page Image">
                            </div>
                            <div *ngIf="!is3D" class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                                    <span>{{ roundDownTowDecimal(file.images[0].height) }}</span>
                                    <span>×</span>
                                    <span>{{ roundDownTowDecimal(file.images[0].width) }}</span>
                                    <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                    </span>
                                </span>
                            </div>
                            <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0"
                                [class.flex-row-reverse]="!isRTL">
                                <span class="p-1 p-lg-2 zx-bg-light">
                                    <div class="d-flex align-items-center text-green zx-text-tiny"
                                        [class.flex-row-reverse]="isRTL">
                                        <span>1</span>
                                        <span>/</span>
                                        <span>
                                            {{file.images.length}}
                                        </span>
                                    </div>
                                </span>
                            </article>
                        </article>
                        <!-- file date -->
                        <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                            <!-- [up container] -->
                            <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- name -->
                                <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span class="d-sm-none">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:17}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">
                                            ...
                                        </span>
                                    </span>
                                    <span class="d-none d-sm-flex">
                                        <span>
                                            {{getDisplayFileNameAfterSplit(file) | slice:0:40}}
                                        </span>
                                        <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">
                                            ...
                                        </span>
                                    </span>
                                </span>
                                <!-- total file price – לא ב-3D (מחיר 0) -->
                                <span *ngIf="!is3D" class="px-1 px-lg-3 zx-min-w-price" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span class="zx-text-small">
                                        {{
                                        roundDownTowDecimal(
                                        file.price.copies *
                                        file.price.pages *
                                        file.price.pricePerPage)
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </div>

                            <!-- [settings] -->
                            <div class="d-flex flex-column flex-wrap gap-1 gap-lg-2" [class.flex-sm-row]="isRTL"
                                (click)="explainHowToChaingeSettings()" [class.flex-sm-row-reverse]="!isRTL">
                                <!-- 3D PH - material + print settings + additional info -->
                                <ng-container *ngIf="isPH && is3D">
                                    <!-- Material + color (mobile: same row; desktop: material row includes color) -->
                                    <div class="d-flex flex-wrap gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <b class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                {{ ('product-material.name.' + branchName + '-' + file.settings?.material) | translate }}
                                            </b>
                                        </div>
                                        <!-- color - in same row as material (especially for mobile) -->
                                        <div *ngIf="file.settings?.color" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                {{ ('product-color.' + file.settings.color) | translate }}
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Print settings: fill, copies, post-production -->
                                    <div class="d-flex flex-wrap gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <!-- fill -->
                                        <div *ngIf="file.settings?.fill != null && product3D?.properties?.fill?.length" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                {{ (file.settings.fill * 100 | number:'1.0-0') }}%
                                            </span>
                                        </div>
                                        <!-- copies -->
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <ng-container *ngIf="(file.settings?.numOfCopies || 1) === 1">{{ "printing-table.copy-one" | translate }}</ng-container>
                                                <ng-container *ngIf="(file.settings?.numOfCopies || 1) !== 1">{{ file.settings?.numOfCopies || 1 }} {{ "printing-table.copies" | translate }}</ng-container>
                                            </span>
                                        </div>
                                        <!-- post-production - only if product has this option and file has it selected -->
                                        <ng-container *ngIf="product3D?.properties?.postProduction">
                                            <ng-container *ngFor="let pp of product3D.properties.postProduction">
                                                <div *ngIf="pp.available && file.settings?.postProduction?.includes(pp.name)"
                                                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                                    <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                        {{ ('product-post-production.' + pp.name) | translate }}
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                    <!-- Additional info for operator - separate row (mobile + desktop) - only when there is content -->
                                    <div *ngIf="(file.settings?.estimatedLength != null || file.settings?.estimatedWidth != null || file.settings?.estimatedHeight != null) || file.settings?.usage || file.settings?.additionalNotes"
                                        class="d-flex flex-column gap-1 pt-2 mt-1 zx-border-top-gray-25-pr w-100" style="padding-top: 8px; flex-basis: 100%;">
                                        <span class="zx-text-tiny opacity-75" [class.zx-text-white]="isDarkMode">
                                            {{ 'printing-table.additional-info-for-operator' | translate }}
                                        </span>
                                        <div class="d-flex flex-wrap gap-1 align-items-center zx-text-tiny" [class.flex-row-reverse]="!isRTL" [class.zx-text-white]="isDarkMode">
                                            <div class="d-flex flex-column flex-md-row gap-1 align-items-md-center" [class.flex-row-reverse]="!isRTL">
                                            <!-- estimated dimensions -->
                                            <span *ngIf="file.settings?.estimatedLength != null || file.settings?.estimatedWidth != null || file.settings?.estimatedHeight != null">
                                                {{ 'printing-table.estimated-dimensions' | translate }}: {{ file.settings?.estimatedLength != null ? file.settings.estimatedLength : '-' }} × {{ file.settings?.estimatedWidth != null ? file.settings.estimatedWidth : '-' }} × {{ file.settings?.estimatedHeight != null ? file.settings.estimatedHeight : '-' }} {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                            <span *ngIf="(file.settings?.estimatedLength != null || file.settings?.estimatedWidth != null || file.settings?.estimatedHeight != null) && file.settings?.usage" class="d-none d-md-inline"> | </span>
                                            <!-- usage -->
                                            <span *ngIf="file.settings?.usage">
                                                {{ 'printing-table.3dprint-usage' | translate }}: {{ (file.settings.usage === 'other' && file.settings.usageOther) ? file.settings.usageOther : ('printing-table.usage.' + file.settings.usage | translate) }}
                                            </span>
                                            </div>
                                            <!-- additional notes -->
                                            <span *ngIf="file.settings?.additionalNotes" class="w-100">
                                                {{ 'printing-table.additional-notes' | translate }}: {{ file.settings.additionalNotes }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- 2D PH - paper & bw & scale -->
                                <ng-container *ngIf="isPH && !is3D">
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <b class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                {{ orderSummaryPhPaperTypeNameKey(file.settings?.paperType) | translate }}
                                            </b>
                                        </div>
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.bw">{{ "printing-table.color-color" | translate }}</span>
                                                <span *ngIf="file.settings.bw">{{ "printing-table.color-bandw" | translate }}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="!is3D && (!file.settings?.scale || file.settings?.scale === 100)"
                                            class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">{{ "order-summary-resize-original" | translate }}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="!(!file.settings?.scale || file.settings?.scale === 100)" class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="file.settings?.scale > 100">{{ "order-summary-resize-bigger" | translate }}</span>
                                                <span *ngIf="file.settings?.scale < 100">{{ "order-summary-resize-smaller" | translate }}</span>
                                                <span>{{ file.settings?.scale }}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.center">{{ "order-summary-not-centered" | translate }}</span>
                                                <span *ngIf="file.settings.center">{{ "order-summary-is-centered" | translate }}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="!file.settings?.scale || file.settings?.scale === 100" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.cmFromTop">{{ "order-summary-not-borders" | translate }}</span>
                                                <span *ngIf="file.settings.cmFromTop">{{ "order-summary-is-borders" | translate }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- non-PH (express/plotter) -->
                                <ng-container *ngIf="!isPH">
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <b class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">{{ orderSummaryPhPaperTypeNameKey(file.settings?.paperType) | translate }}</b>
                                        </div>
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.bw">{{ "printing-table.color-color" | translate }}</span>
                                                <span *ngIf="file.settings.bw">{{ "printing-table.color-bandw" | translate }}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="!is3D && (!file.settings?.scale || file.settings?.scale === 100)" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">{{ "order-summary-resize-original" | translate }}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="is3D" class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.rotation || file.settings.rotation === 0">{{ "printing-table.rotated-not" | translate }}</span>
                                                <span *ngIf="file.settings.rotation && file.settings.rotation !== 0">{{ "printing-table.rotated" | translate }} {{ file.settings.rotation }}°</span>
                                            </span>
                                        </div>
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.align || file.settings.align === 'center'">{{ "order-summary-is-centered" | translate }}</span>
                                                <span *ngIf="file.settings.align && file.settings.align !== 'center'">{{ "printing-table.align." + file.settings.align | translate }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div *ngIf="!is3D" class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div *ngIf="!(!file.settings?.scale || file.settings?.scale === 100)" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="file.settings?.scale > 100">{{ "order-summary-resize-bigger" | translate }}</span>
                                                <span *ngIf="file.settings?.scale < 100">{{ "order-summary-resize-smaller" | translate }}</span>
                                                <span *ngIf="file.settings?.scale === 100">{{ "order-summary-resize-original" | translate }}</span>
                                                <span *ngIf="file.settings?.scale !== 100">{{ file.settings?.scale }}%</span>
                                            </span>
                                        </div>
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.center">{{ "order-summary-not-centered" | translate }}</span>
                                                <span *ngIf="file.settings.center">{{ "order-summary-is-centered" | translate }}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="!file.settings?.scale || file.settings?.scale === 100" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.cmFromTop">{{ "order-summary-not-borders" | translate }}</span>
                                                <span *ngIf="file.settings.cmFromTop">{{ "order-summary-is-borders" | translate }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div *ngIf="!is3D && !(!file.settings?.scale || file.settings?.scale === 100)" class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                            <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                                <span *ngIf="!file.settings.cmFromTop">{{ "order-summary-not-borders" | translate }}</span>
                                                <span *ngIf="file.settings.cmFromTop">{{ "order-summary-is-borders" | translate }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- [down container] – לא ב-PH 3D (שורת עותקים + מחיר לעותק מיותרת שם) -->
                            <span *ngIf="(!isPH || !is3D) && (file.price.pages > 1 || file.price.copies > 1)"
                                [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode"
                                [class.zx-ltr]="!isRTL">
                                <!-- pages -->
                                <span *ngIf="file.price.pages > 1">
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        file.price.pages
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.pages-short" | translate }}
                                    </span>
                                </span>
                                <!-- , -->
                                <span *ngIf="file.price.pages > 1 && file.price.copies > 1">
                                    <!-- <span class="zx-100-opacity">_</span> -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                </span>
                                <span *ngIf="file.price.copies > 1">
                                    <!-- copies -->
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        file.price.copies
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.copies-short" | translate }}
                                    </span>
                                    <!-- , -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                    <!-- price per page -->
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.price-per-copy" | translate }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">:</span>
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        roundDownTowDecimal(
                                        file.price.pricePerPage *
                                        file.price.pages)
                                        }}
                                    </span>
                                    <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                    </span>
                                </span>
                            </span>

                        </article>
                        <!-- // file date -->
                    </article>
                    <!-- // 1st line -->

                    <!-- 2nd line -->
                    <article *ngIf="file.images.length > 1" class="d-flex row w-100 pt-1" [class.zx-ltr]="!isRTL">
                        <article *ngFor="let image of file.images; let j = index" [class.d-flex]="j !== 0"
                            [class.d-none]="j === 0" class="col-4 col-sm-3 col-md-2 pb-1">
                            <!-- 2 + image -->
                            <article
                                class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                                <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                    <img class="w-100 h-100 object-fit-contain" [src]="file.images[j].path"
                                        alt="File Page Image">
                                </div>
                                <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                    <span class="zx-text-tiny">
                                        <span>{{ roundDownTowDecimal(file.images[j].height) }}</span>
                                        <span>×</span>
                                        <span>{{ roundDownTowDecimal(file.images[j].width) }}</span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </span>
                                </div>
                                <article class="position-absolute d-flex w-100 top-0">
                                    <span class="p-1 p-lg-2 zx-bg-light">
                                        <div class="d-flex align-items-center text-green zx-text-tiny"
                                            [class.flex-row-reverse]="isRTL">
                                            <span>
                                                {{j + 1}}
                                            </span>
                                            <span>/</span>
                                            <span>
                                                {{file.images.length}}
                                            </span>
                                        </div>
                                    </span>
                                </article>
                            </article>
                            <!-- // 2 + image -->
                        </article>
                    </article>
                    <!-- // 2nd line -->
                </section>
                </ng-container>
                <!-- // files -->

            </div>
        </div>
        <!-- // files [ph] -->

        <!-- files and price TOTAL line -->
        <section class="d-flex flex-column align-items-end w-100 pt-1 gap-1">
            <!-- total price -->
            <div class="w-100 px-3 py-2 d-flex justify-content-between align-items-center" [class.zx-ltr]="!isRTL">

                <!-- title and files + isMnigerOrder -->
                <div
                    class="d-flex flex-column flex-lg-row align-items-start align-items-lg-end gap-lg-2 flex-grow-1 justify-content-between">
                    <!-- title and files -->
                    <span class="d-flex gap-2"
                        [class.flex-column]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                        [class.flex-sm-row]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && isRTL"
                        [class.flex-sm-row-reverse]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && !isRTL"
                        [class.align-items-sm-end]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                        [class.align-items-end]="!(totalPriceData && totalPriceData.points && totalPriceData.points > 0)">
                        <span class="zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.total-price' | translate }}
                        </span>
                        <span>
                            <span [class.text-white]="isDarkMode">
                                <span *ngIf="files && files.length > 1">
                                    <b class="zx-text-small">
                                        {{ files.length }}
                                    </b>
                                    <b class="zx-text-small">
                                        {{ 'printing-table.files' | translate }}
                                    </b>
                                </span>
                                <b class="zx-text-small" *ngIf="files && files.length === 1">
                                    {{ 'printing-table.one-file' | translate }}
                                </b>
                            </span>
                            <span
                                *ngIf="totalPriceData.fixProductsTotalPrice > 0 && totalPriceData.totalOrderPrice > 0">
                                <span>,</span>
                                <span class="zx-100-opp">-</span>
                            </span>
                            <span *ngIf="totalPriceData.fixProductsTotalPrice > 0" [class.text-white]="isDarkMode">
                                <span *ngIf="getAmountOfFixProducts(fixProductsArray) > 1">
                                    <b class="zx-text-small">
                                        {{ getAmountOfFixProducts(fixProductsArray) }}
                                    </b>
                                    <b class="zx-text-small">
                                        {{ 'fix-products.num-of-products.many' | translate }}
                                    </b>
                                </span>
                                <b class="zx-text-small" *ngIf="getAmountOfFixProducts(fixProductsArray) === 1">
                                    {{ 'fix-products.num-of-products.one' | translate }}
                                </b>
                            </span>
                        </span>
                    </span>

                    <!-- isAdminOrder ? -->
                    <span *ngIf="isAdminOrder" class="zx-text-tiny-tiny pb-lg-1 px-lg-2" [class.text-white]="isDarkMode"
                        [class.zx-text-pink]="!isDarkMode">
                        <b>
                            ·
                        </b>
                        <span>
                            {{ "my-orders.manager-order" | translate }}
                        </span>
                        <b>
                            ·
                        </b>
                    </span>
                </div>
                <!-- // title and files + isMnigerOrder -->

                <!-- pricing calc -->
                <span class="d-flex align-items-end gap-1 gap-lg-2"
                    [class.flex-column]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                    [class.flex-sm-row]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && isRTL"
                    [class.flex-sm-row-reverse]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && !isRTL"
                    [class.zx-text-white]="isDarkMode">
                    <!-- before discount price -->
                    <span [class.zx-ltr]="!isRTL">
                        <span class="opacity-75 zx-text-tiny" [class.zx-ltr]="!isRTL" *ngIf="!((totalPriceData.totalOrderPrice - totalPriceData.totalOrderPriceBeforeDiscount < 0.05) &&
                        (totalPriceData.totalOrderPrice - totalPriceData.totalOrderPriceBeforeDiscount > -0.05)) &&
                             totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0">
                            <span class="strikethrough">
                                <span>
                                    {{ roundDownTowDecimal(totalPriceData.totalOrderPriceBeforeDiscount +
                                    totalPriceData.fixProductsTotalPrice) }}
                                </span>
                                <span>
                                    {{ 'printing-table.nis' | translate }}
                                </span>
                            </span>
                            <span class="zx-100-opacity">.</span>
                        </span>
                        <!-- total price if have points -->
                        <span class="zx-text-small" [class.zx-ltr]="!isRTL"
                            *ngIf="totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0 && totalPriceData.points >= 0.1">
                            <span>
                                {{ roundDownTowDecimal(totalPriceData.totalOrderPrice +
                                totalPriceData.fixProductsTotalPrice) }}
                            </span>
                            <span class="zx-text-tiny-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </span>
                            <span>:</span>
                        </span>
                    </span>
                    <span>
                        <!-- real price (after discount) -->
                        <span *ngIf="(totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0) ||
                            totalPriceData.fixProductsTotalPrice > 0">
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal( totalPriceData.totalOrderPrice - totalPriceData.points +
                                totalPriceData.fixProductsTotalPrice) :
                                totalPriceData.fixProductsTotalPrice +
                                (collectionData.selectedCollectPrice ? collectionData.selectedCollectPrice : 0) }}
                            </b>
                            <b class="zx-text-tiny-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </b>
                        </span>
                        <!-- if have EAZIX points -->
                        <span
                            *ngIf="totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0 && totalPriceData.points >= 0.1">
                            <span class="zx-text-tiny-tiny">+</span>
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal(totalPriceData.points) :
                                roundDownTowDecimal(totalPriceData.totalOrderPrice) }}
                            </b>
                            <b class="zx-text-tiny-tiny">
                                {{ 'printing-table.points-short' | translate }}
                            </b>
                        </span>
                    </span>
                </span>
            </div>

            <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
                [class.flex-row-reverse]="!isRTL">
                <button color="primary" mat-raised-button class="text-white rounded-pill w-100"
                    (click)="approveOrderSummary()">
                    <b *ngIf="is3D && !(isPendingOrder && printingService === 'plotter')">
                        <span class="d-block d-md-none">{{ "order-summary-aprove-and-pricing-short" | translate }}</span>
                        <span class="d-none d-md-block">{{ "order-summary-aprove-and-pricing" | translate }}</span>
                    </b>
                    <b *ngIf="!is3D && !(isPendingOrder && printingService === 'plotter')">
                        {{ "order-summary-aprove" | translate }}
                    </b>
                    <b *ngIf="isPendingOrder && printingService === 'plotter'">
                        {{ "order-summary-aprove-and-print" | translate }}
                    </b>
                </button>
                <button *ngIf="!isPendingOrder" [disabled]="isLoadingAproveOrderSummary" mat-button
                    class="rounded-pill w-100 text-green fw-bold" (click)="closeOrderSummaryDialog()">
                    {{ "order-summary-edit" | translate }}
                </button>
            </div>

        </section>
        <!-- // files and price TOTAL line -->

    </div>
    <!-- // [PH] TO APROVE [PH] ===================================== [PH] TO APROVE [PH] ===================================== [PH] TO APROVE [PH]  -->
















    <!-- IMAGE SORCE ERROR ===================================== IMAGE SORCE ERROR ===================================== IMAGE SORCE ERROR  -->
    <div *ngIf="!isThumbnailsOK"
        class="d-flex flex-grow-1 flex-column align-items-center justify-content-center pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-lg-2 w-100 position-relative">

        <!-- title -->
        <div class="w-100 d-flex flex-column gap-3 gap-lg-4 align-items-center justify-content-center pt-4 pt-lg-0">
            <h6 class="text-center m-0 p-0 zx-text-big fw-bold" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <span>
                    {{ "my-orders.order-expired" | translate }}
                </span>
            </h6>
            <!-- explain -->
            <span class="text-center p-2" [class.zx-ltr]="!isRTL">
                {{ "my-orders.order-expired-explain" | translate }}
            </span>
        </div>
        <!-- // title -->

        <button color="primary" mat-raised-button class="text-white rounded-pill fw-bold mt-3"
            (click)="openRightPlaceDialog()">
            {{ "main-nav.new-order" | translate }}
        </button>

    </div>
    <!-- // IMAGE SORCE ERROR ===================================== IMAGE SORCE ERROR ===================================== IMAGE SORCE ERROR  -->














    <!-- APROVED! - FIX PRODUCTS ====================== APROVED! - FIX PRODUCTS ====================== APROVED! - FIX PRODUCTS  -->
    <div *ngIf="isOrderAproved && !isCreditMode && !isLoading && !isOrderPrinted && !isOrderSaved &&
    (fixProductsArray && fixProductsArray.length > 0 && isFixedProductsAproved && !isFixedProductsPicked && user.phone)"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-md-3 w-100 position-relative"
        [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <!-- title -->
        <div class="w-100 d-flex flex-column gap-3 gap-lg-4 align-items-center justify-content-center pt-4 pt-lg-0">
            <h6 class="text-center m-0 p-0 zx-text-big fw-bold" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <span>
                    {{ "fix-product.summery.title" | translate }}
                </span>
            </h6>
            <!-- explain -->
            <span class="text-center p-2" [class.zx-ltr]="!isRTL">
                {{ "fix-product.summery.explain" | translate }}
            </span>
        </div>
        <!-- // title -->

        <!-- products picking [express] -->
        <div class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">

                <!-- products -->
                <section ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    *ngFor="let product of fixProductsArray; index as i" class="d-flex w-100">

                    <!-- 1st line -->
                    <article class="d-flex gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
                        <!-- product image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img class="w-100 h-100 object-fit-contain"
                                    [src]="'assets/images/fix-products/' + product.productId.previewImage + '.png'"
                                    alt="File Page Image">
                            </div>
                        </article>
                        <!-- product date -->
                        <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                            <!-- [up container] -->
                            <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- name -->
                                <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                    [class.zx-text-white]="isDarkMode">
                                    <span>
                                        {{ "fix-product." + product.productId.name | translate }}
                                    </span>
                                </span>
                                <!-- total file price -->
                                <!-- one -->
                                <span *ngIf="product.numOfCopies === 1" class="px-1 px-lg-3 zx-min-w-price"
                                    [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{ "su-management.units.one" | translate }}
                                    </span>
                                </span>
                                <!-- many -->
                                <span *ngIf="product.numOfCopies > 1" class="px-1 px-lg-3 zx-min-w-price"
                                    [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{
                                        product.numOfCopies
                                        }}
                                    </span>
                                    <span class="zx-text-tiny zx-text-sm-small">
                                        {{ "su-management.units" | translate }}
                                    </span>
                                </span>
                            </div>

                        </article>
                        <!-- // file date -->
                    </article>
                    <!-- // 1st line -->
                </section>

                <!-- // fix products -->

            </div>
        </div>
        <!-- // products picking [express] -->

        <!-- aprove picking fix products btn -->
        <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
            [class.flex-row-reverse]="!isRTL">
            <button color="primary" mat-raised-button class="text-white rounded-pill w-100 zx-max-w-btn"
                (click)="onPickedFixProducts()">
                <b *ngIf="files?.length > 0">
                    {{ "order-summary-aprove-and-print" | translate }}
                </b>
                <b *ngIf="!files || files?.length === 0">
                    {{ "error-content-ok-btn" | translate }}
                </b>
            </button>
        </div>
        <!-- // aprove picking fix products btn -->

    </div>
    <!-- // APROVED! - FIX PRODUCTS ====================== APROVED! - FIX PRODUCTS ====================== APROVED! - FIX PRODUCTS  -->














    <!-- APROVED! - SEND PRINTING ====================== APROVED! - SEND PRINTING ====================== APROVED! - SEND PRINTING  -->
    <div *ngIf="isOrderAproved && !isCreditMode && !isLoading && !isOrderPrinted && !isOrderSaved &&
    !emptyPaymentForOrder && !phPaymentForOrder &&
    (!fixProductsArray || fixProductsArray?.length === 0 ||
    (fixProductsArray?.length > 0 && (isFixedProductsNeedsToBePayed || (!isFixedProductsAproved && !isFixedProductsPayed && isFixedProductsPicked))))"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-md-3 w-100 position-relative"
        [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <!-- <u>isPH: {{isPH}}</u>
        <u>isCvvConfirmed: {{isCvvConfirmed}}</u> -->
        <!-- ===== back to order main info and back to CC ===== -->
        <div *ngIf="!(isPH && isCvvConfirmed)" class="d-flex w-100 justify-content-between mt-4">
            <!-- <u>INNNNNN!!!</u> -->
            <!-- --- order main info --- -->
            <div matRipple (click)="disaproveOrderSummary()"
                class="p-2 px-lg-3 d-flex gap-2 gap-sm-3 align-items-center justify-content-center rounded-2 flex-shrink-0 text-gray c-pointer"
                [class.zx-bg-gray]="!isDarkMode" [class.flex-row-reverse]="!isRTL">

                <!-- pricing calc -->
                <div class="d-flex align-items-end gap-1 gap-lg-2"
                    [class.flex-column]="totalPriceData && totalPriceData.points && totalPriceData.points > 0"
                    [class.flex-sm-row]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && isRTL"
                    [class.flex-sm-row-reverse]="totalPriceData && totalPriceData.points && totalPriceData.points > 0 && !isRTL"
                    [class.zx-text-white]="isDarkMode">
                    <span>
                        <!-- real price (after discount) -->
                        <span *ngIf="(totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0) ||
                            totalPriceData.fixProductsTotalPrice > 0">
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal( totalPriceData.totalOrderPrice - totalPriceData.points +
                                totalPriceData.fixProductsTotalPrice) :
                                totalPriceData.fixProductsTotalPrice }}
                            </b>
                            <b class="zx-text-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </b>
                        </span>
                        <!-- if have EAZIX points -->
                        <span
                            *ngIf="totalPriceData.totalOrderPrice > 0 && totalPriceData.totalOrderPriceBeforeDiscount > 0 && totalPriceData.points >= 0.1">
                            <span class="zx-text-tiny">+</span>
                            <b>
                                {{ totalPriceData.totalOrderPrice > totalPriceData.points ?
                                roundDownTowDecimal(totalPriceData.points) :
                                roundDownTowDecimal(totalPriceData.totalOrderPrice) }}
                            </b>
                            <b class="zx-text-tiny">
                                {{ 'printing-table.points-short' | translate }}
                            </b>
                        </span>
                    </span>
                </div>

                <!-- back to summery -->
                <div *ngIf="isLogedIn && !isPendingOrder"
                    class="d-flex justify-content-center align-items-center gap-1 gap-lg-2 c-pointer zx-z-index-2 p-1 rounded-2">
                    <div class="d-flex justify-content-center c-pointer">
                        <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                            class="svg zx-small-icon-size c-pointer">
                        <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                            class="svg zx-small-icon-size c-pointer">
                    </div>
                </div>

            </div>
            <!-- // --- order main info --- -->

            <!-- --- order CC --- -->
            <div matRipple (click)="editCCOrderSummary()"
                class="p-2 px-lg-3 d-flex gap-2 gap-sm-3 align-items-center justify-content-center rounded-2 flex-shrink-0 text-gray c-pointer"
                [class.zx-bg-gray]="!isDarkMode" [class.flex-row-reverse]="!isRTL">
                <b class="zx-text-small" [class.zx-text-white]="isDarkMode">
                    <span class="d-sm-none">
                        {{ 'order-summary-cc.short' | translate }}
                    </span>
                    <span class="d-none d-sm-inline">
                        {{ 'order-summary-cc' | translate }}
                    </span>
                </b>
                <span class="d-flex flex-column">
                    <b *ngIf="user.zCreditInfo && user.zCreditInfo.cardNum && user.zCreditInfo.cardNum > 0">
                        {{ getCCLastDigits(user.zCreditInfo.cardNum) }}
                    </b>
                    <span *ngIf="!user.zCreditInfo || !user.zCreditInfo.cardNum || user.zCreditInfo.cardNum === 0">
                        {{ 'order-summary-no-set' | translate }}
                    </span>
                </span>
                <!-- back to cc edit -->
                <div
                    class="d-flex justify-content-center align-items-center gap-1 gap-lg-2 c-pointer zx-z-index-2 p-1 rounded-2">
                    <div class="d-flex justify-content-center c-pointer">
                        <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                            class="svg zx-small-icon-size c-pointer">
                        <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                            class="svg zx-small-icon-size c-pointer">
                    </div>
                </div>

            </div>
            <!-- // --- order CC --- -->

        </div>
        <!-- // ===== back to order main info and back to CC ===== -->

        <!-- title -->
        <div
            class="w-100 d-flex flex-column gap-3 gap-lg-4 flex-grow-1 align-items-center justify-content-center pt-4 pt-lg-0">
            <h6 class="text-center m-0 p-0 zx-text-big fw-bold d-flex align-items-center justify-content-center flex-wrap" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <span
                    *ngIf="!(printingService === 'express' && isPendingOrder) && (user.phone && user.phone !== '') && (isCvvConfirmed || isAdminOrder || isPendingOrder)"
                    class="d-flex flex-column align-items-center justify-content-center">
                    <span class="pb-2">{{ "when-to-print-title" | translate }}</span>
                    <div *ngIf="printingService !== 'ph'" class="d-inline-flex align-items-center gap-2 mx-1" [class.flex-row-reverse]="!isRTL">
                        <span class="zx-text-big" style="color: var(--zx-green);">
                            {{ "choose-branch.naming." + printingService + "." + branchName | translate }}
                        </span>
                        <img [src]="'assets/images/' + getPrintingService(printingService) + '-icon.svg'"
                            alt="choosen printing system icon" class="zx-small-small-plus-icon-size">
                        <img [src]="'assets/images/branches/' + branchName + '.png'" alt="choosen printing system icon"
                            class="zx-small-small-plus-icon-size c-pointer">
                    </div>
                </span>
                <span
                    *ngIf="(printingService === 'express' && isPendingOrder) && (user.phone && user.phone !== '') && (isCvvConfirmed || isAdminOrder || isPendingOrder)">
                    {{ "when-to-print-enter-code" | translate }}
                </span>
                <span *ngIf="(user.phone && user.phone !== '') && !(isCvvConfirmed || isAdminOrder || isPendingOrder)">
                    {{ "order-summary.enter-cvv.title" | translate }}
                </span>
                <span *ngIf="!(user.phone && user.phone !== '')">
                    {{ "phone-dialog-title" | translate }}
                </span>
            </h6>
            <!-- success-icon -->
            <img *ngIf="(user.phone && user.phone !== '') && (isCvvConfirmed || isAdminOrder || isPendingOrder)"
                src="assets/images/success-icon.svg" class="svg zx-success-icon" alt="successfull order">
            <!-- phone explain -->
            <span *ngIf="!(user.phone && user.phone !== '')" class="text-center p-2" [class.zx-ltr]="!isRTL">
                {{ "phone-dialog-explain" | translate }}
            </span>
            <!-- cvv explain -->
            <span *ngIf="(user.phone && user.phone !== '') && !(isCvvConfirmed || isAdminOrder || isPendingOrder)"
                class="text-center p-2" [class.zx-ltr]="!isRTL">
                <span>
                    {{ "order-summary.enter-cvv.explain" | translate }}
                </span>
                <span>
                    {{ user.zCreditInfo?.cardNum ? user.zCreditInfo.cardNum : '-' }}
                </span>
            </span>
        </div>
        <!-- // title -->

        <!-- =========== now or after options === plotter =========== -->
        <div *ngIf="(user.phone && user.phone !== '') && printingService === 'plotter' && (isCvvConfirmed || isAdminOrder || isPendingOrder)"
            class="w-100 d-flex flex-column justify-content-between align-items-center flex-grow-1">
            <p class="max-w-explain text-center" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <b>
                    <span>
                        {{ "when-to-print-explanation-now-plotter-1" | translate }}
                    </span>
                    <span>
                        {{ "choose-branch.naming." + branchName | translate }}
                    </span>
                    <span>
                        {{ "when-to-print-explanation-now-plotter-2" | translate }}
                    </span>
                </b>
                <span>
                    {{ "when-to-print-explanation-now-plotter-3" | translate }}
                </span>
            </p>
            <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
                [class.flex-row-reverse]="!isRTL">
                <button color="primary" mat-raised-button class="text-white rounded-pill w-100 fw-bold"
                    (click)="onSendOrderToPrint()">
                    {{ "when-to-print-btn-now" | translate }}
                </button>
                <button *ngIf="!isPendingOrder" mat-button class="rounded-pill w-100 text-green fw-bold"
                    (click)="onSaveOrderForAfter()">
                    {{ "when-to-print-btn-after" | translate }}
                </button>
            </div>
        </div>
        <!-- // =========== now or after options === plotter =========== -->

        <!-- =========== now or after options === express =========== -->
        <div *ngIf="(user.phone && user.phone !== '') && printingService === 'express' && !emptyPaymentForOrder && (isCvvConfirmed || isAdminOrder || isPendingOrder)"
            (click)="focusPrintingCodeInput()"
            class="w-100 d-flex flex-column justify-content-between align-items-center flex-grow-1">
            <p class="max-w-explain text-center" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <b>
                    <span>
                        {{ "when-to-print-explanation-now-express-1" | translate }}
                    </span>
                    <span>
                        {{ "choose-branch.naming." + printingService + "." + branchName | translate }}
                    </span>
                    <span>
                        {{ "when-to-print-explanation-now-express-2" | translate }}
                    </span>
                </b>
            </p>

            <div class="w-100 d-flex flex-grow-1">
                <!-- printing code input - [express] -->
                <form *ngIf="printingService === 'express'" class="d-flex flex-column justify-content-between w-100 zx-printing-code-form"
                    #expressCode="ngForm">
                    <mat-form-field class="zx-code-input-con px-4 pb-1 pb-lg-2 zx-code-input-con-relative"
                        [class.zx-code-input-con-empty]="expressCodeInput.value === '' || !expressCodeInput.value"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                        <input #expressInput matInput name="expressPrintingCode" ngModel type="text"
                            [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                            [placeholder]="'when-to-print-printing-code' | translate" #expressCodeInput="ngModel"
                            required minlength="5" maxlength="5" pattern="^[0-9]{5}$" inputmode="numeric">
                        <mat-error *ngIf="expressCodeInput.invalid"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            <span *ngIf="expressCodeInput.hasError('required')" class="d-inline-block"
                                [class.zx-text-white]="isDarkMode">
                                {{ "when-to-print-printing-code-not-valid" | translate }}
                            </span>
                            <span *ngIf="expressCodeInput.hasError('maxlength')" class="d-inline-block"
                                [class.zx-text-white]="isDarkMode">
                                {{ "when-to-print-printing-code-not-valid-maxlength" | translate }}
                            </span>
                            <span *ngIf="expressCodeInput.hasError('pattern')" class="d-inline-block"
                                [class.zx-text-white]="isDarkMode">
                                {{ "when-to-print-printing-code-not-valid-pattern" | translate }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                    <div class="zx-printing-code-display text-center" *ngIf="isAdminOrder || skipCode">
                        <mat-spinner *ngIf="isLoadingPrintingCode" 
                            class="zx-small-plus-icon-size zx-medium-icon-size-lg" 
                            [diameter]="20"></mat-spinner>
                        <b *ngIf="!isLoadingPrintingCode" [class.zx-text-pink]="!isDarkMode"
                            [class.text-white]="isDarkMode">
                            <span>{{ "when-to-print-printing-code" | translate }}</span>
                            <span>:</span>
                            <span class="zx-100-opp">_</span>
                            <span>{{ printingCode }}</span>
                        </b>
                    </div>
                    <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
                        [class.flex-row-reverse]="!isRTL">
                        <button *ngIf="files && files.length > 0" color="primary" mat-raised-button type="submit"
                            [disabled]="expressCode.invalid" class="text-white rounded-pill w-100 zx-max-w-btn fw-bold"
                            (click)="onSendOrderToPrint(expressCodeInput.value)">
                            {{ "when-to-print-btn-now" | translate }}
                        </button>
                        <button
                            *ngIf="files && files.length > 0 && !isPendingOrder && (!fixProductsArray || fixProductsArray.length === 0) && !isFixedProductsNeedsToBePayed"
                            mat-button class="rounded-pill w-100 text-green fw-bold" (click)="onSaveOrderForAfter()">
                            {{ "when-to-print-btn-after" | translate }}
                        </button>
                        <button *ngIf="(!files || files.length === 0) && !isPendingOrder" color="primary"
                            mat-raised-button class="text-white rounded-pill w-100 zx-max-w-btn fw-bold"
                            (click)="onSendOrderToPrint(expressCodeInput.value)">
                            {{ "order-summary-aprove" | translate }}
                        </button>
                    </div>
                </form>
                <!-- // printing code input - [express] -->
            </div>

        </div>
        <!-- // =========== now or after options === express =========== -->

        <!-- =========== now or after options === PH =========== -->
        <div *ngIf="(user.phone && user.phone !== '') && printingService === 'ph' && (isCvvConfirmed || isAdminOrder)"
            class="w-100 d-flex flex-column justify-content-between align-items-center flex-grow-1">

            <div class="w-100 d-flex justify-content-center align-items-end position-absolute bottom-0"
                style="opacity: 22%; max-height: 600px; max-width:600px">
                <div id="animationConfettiContainerPH"></div>
            </div>

            <p class="max-w-explain text-center" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <span>
                    <span>
                        {{ "collect.order-expected." + collectionData?.selectedCollectOption | translate }}
                    </span>
                    <!-- משלוח: אין selectedPlace — הכתובת ב-deliveryAddress (מפורט ב-ph-printing-table) -->
                    <span *ngIf="collectionData?.selectedCollectOption !== 'delivery' && selectedPlace">
                        <b>
                            {{ selectedPlace.translatedName }}
                        </b>
                        <span>
                            {{ "collect.in-adress" | translate }}
                        </span>
                    </span>
                    <b *ngIf="collectionData?.selectedCollectOption === 'delivery' && collectionData?.deliveryAddress?.fullAddress">
                        {{ collectionData.deliveryAddress.fullAddress }}
                    </b>
                    <b *ngIf="collectionData?.selectedCollectOption !== 'delivery' && selectedPlace?.translatedAddress">
                        {{ selectedPlace.translatedAddress }}
                    </b>
                    <span>
                        {{ 'collect.no-later-than' | translate }}
                    </span>
                    <span>
                        {{ 'collect.times.at-day' | translate }}
                    </span>
                    <span>
                        {{ collectionData?.obligatedDay }}
                    </span>
                    <span>
                        {{ collectionData?.obligatedDate }}
                    </span>
                    .
                </span>
            </p>

            <p class="max-w-explain text-center zx-text-pink" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                {{ 'collect.order-track.exp' | translate }}
            </p>

            <div class="d-flex justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-2"
                [class.flex-row-reverse]="!isRTL">
                <button color="primary" mat-raised-button class="text-white rounded-pill w-100 fw-bold"
                    (click)="openRightPlaceDialog()">
                    {{ "main-nav.new-order" | translate }}
                </button>
                <button *ngIf="!isPendingOrder" mat-button class="rounded-pill w-100 text-green fw-bold"
                    (click)="goToMyOrders()">
                    {{ "collect.order-track" | translate }}
                </button>
            </div>
        </div>
        <!-- // =========== now or after options === PH =========== -->

        <!-- // =========== enter CVV option  =========== -->
        <div *ngIf="(user.phone && user.phone !== '') && !(isCvvConfirmed || isAdminOrder || isPendingOrder)"
            class="d-flex flex-column gap-2 pag-lg-3 align-items-center w-100">

            <span class="spacer"></span>

            <!-- ================= FIELD - CVV -->
            <form class="w-100 d-flex flex-column gap-4" [formGroup]="cvvForm">
                <div class="d-flex w-100 align-items-center gap-2 gap-lg-3">
                    <span [class.zx-ltr]="!isRTL">
                        <span>
                            <span>
                                CVV
                            </span>
                            <span>:</span>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <!-- inner FIELD - cvv -->
                    <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1 zx-min-h-phone-input"
                        [class.zx-ltr]="!isRTL">
                        <mat-label>
                            CVV
                        </mat-label>
                        <input [class.d-none]="isLoadingUpdates" matInput type="text" formControlName="cvv"
                            [placeholder]="'CVV'" required [class.zx-ltr]="!isRTL" inputmode="numeric">
                        <div [class.d-none]="!isLoadingUpdates" class="w-100 d-flex justify-content-center"
                            [class.zx-ltr]="!isRTL" style="min-height: 24px;">
                            <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                        </div>
                        <mat-error *ngIf="cvvForm.get('cvv').invalid && !cvvForm.get('cvv').hasError('notMatch')"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "my-cc-card-cvv.error" | translate }}
                        </mat-error>
                        <mat-error *ngIf="cvvForm.get('cvv').hasError('notMatch') && tryCeckCvv < (MaxCeckCvvTry / 2)"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "my-cc-card-cvv.not-mach" | translate }}
                            {{ user.zCreditInfo?.cardNum ? user.zCreditInfo.cardNum : '-' }}.
                        </mat-error>
                        <mat-error *ngIf="cvvForm.get('cvv').hasError('notMatch') && tryCeckCvv >= (MaxCeckCvvTry / 2)"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "my-cc-card-cvv.not-mach.try.1" | translate }}
                            {{ MaxCeckCvvTry - tryCeckCvv }}
                            {{ "my-cc-card-cvv.not-mach.try.2" | translate }}.
                        </mat-error>
                        <!-- clear field -->
                        <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.d-flex]="cvvForm.get('cvv').value && cvvForm.get('cvv').value !== ''"
                            [class.d-none]="!(cvvForm.get('cvv').value && cvvForm.get('cvv').value !== '')"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="clearCvvField()"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                    </mat-form-field>
                    <!-- // inner FIELD - cvv -->
                </div>
                <!-- // ================= FIELD - CVV -->
            </form>

            <span class="spacer"></span>

            <button (click)="onCheckUserCvv()" [disabled]="cvvForm.get('cvv').invalid" color="primary" mat-raised-button
                class="rounded-pill w-100 text-white">
                {{ ((isPH && printingService === 'ph') ?
                'order-summary-aprove-and-print' : 'error-content-ok-btn')
                | translate }}
            </button>
        </div>
        <!-- // =========== enter CVV option  =========== -->

        <!-- === enter phone option === -->
        <div *ngIf="!(user.phone && user.phone !== '')"
            class="d-flex flex-column gap-2 pag-lg-3 align-items-center w-100">

            <span class="spacer"></span>

            <!-- the phone is added with an SMS code in the phone dialog -->
            <button (click)="onAddPhone()" [disabled]="isLoading"
                color="primary" mat-raised-button class="rounded-pill w-100 text-white">
                {{ "phone-dialog-add-phone" | translate }}
            </button>
        </div>
        <!-- // === enter phone option === -->

    </div>
    <!-- // APROVED! - SEND PRINTING ====================== APROVED! - SEND PRINTING ====================== APROVED! - SEND PRINTING  -->














    <!-- Empty payment request – fallback when pay failed (no blank dialog) -->
    <div *ngIf="emptyPaymentForOrder && isOrderAproved && !isOrderPrinted && !isOrderSaved && !isCreditMode && !isLoading"
        class="d-flex flex-grow-1 flex-column align-items-center justify-content-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.text-white]="isDarkMode">
        <h6 class="text-center fw-bold m-0">
            {{ "my-orders.empty-payment-request.approve-and-pay" | translate }}
        </h6>
        <p class="text-center m-0" [class.zx-ltr]="!isRTL">
            <b>{{ roundDownTowDecimal(totalPriceData?.totalOrderPrice ?? 0) }}</b>
            <span class="zx-text-tiny">{{ "printing-table.nis" | translate }}</span>
        </p>
        <button mat-raised-button color="primary" class="rounded-pill w-100 text-white fw-bold"
            (click)="retryEmptyPaymentRequest()">
            {{ ("order-summary-confirm-card-info.and-payment") | translate }}
        </button>
        <button mat-button class="rounded-pill w-100 text-green fw-bold" (click)="editCCOrderSummary()">
            {{ "main-nav.methods-of-payment" | translate }}
        </button>
    </div>

    <!-- CC EDIT! ===================================== CC EDIT! ===================================== CC EDIT!  -->
    <div [class.zx-ltr]="!isRTL"
        *ngIf="isOrderAproved && isCreditMode && (!isLoading && !isOrderPrinted && !isOrderSaved)"
        [class.zx-text-white]="isDarkMode"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-4 gap-1 w-100 position-relative"
        [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <h3 class="text-center fw-bold m-0 p-0 pb-3 pt-1 pt-lg-0">
            <span *ngIf="user.zCreditInfo?.token && user.zCreditInfo.token !== ''">
                {{ "main-nav.methods-of-payment" | translate }}
            </span>
            <span *ngIf="!(user.zCreditInfo?.token && user.zCreditInfo.token !== '')">
                {{ "my-cc-set-credit-info" | translate }}
            </span>
        </h3>

        <div class="w-100 d-flex flex-column gap-2 flex-grow-1">
            <!-- credit exists – במצב תשלום PH מדלגים ישר לטופס -->
            <div *ngIf="!phPaymentForOrder && !emptyPaymentForOrder && user.zCreditInfo?.token && user.zCreditInfo.token !== ''" class="p-0 px-lg-4 w-100 d-flex">
                <article
                    class="p-3 rounded-3 shadow-85 w-100 d-flex flex-column gap-2 gap-md-3 position-relative zx-h-140-sm"
                    [class.bg-white]="!isDarkMode" [class.zx-bg-dark-light-border]="isDarkMode">
                    <span class="px-2 pt-1" [class.text-start]="!isRTL">
                        {{ "my-cc-credit-in-use" | translate }}
                    </span>
                    <div class="d-flex align-items-center gap-2">
                        <img class="card-img zx-medium-big-icon-size" src="../../../assets/images/credit-card-icon.svg"
                            alt="Creadit Card Icon">
                        <span class="zx-text-big zx-text-sm-huge">
                            <span> {{ user.zCreditInfo?.cardNum ? getCCLastDigits(user.zCreditInfo.cardNum) : '****'
                                }}
                            </span>
                            <span class="zx-100-opp">-</span>
                            <span>- **** - **** - ****</span>
                        </span>
                    </div>
                    <!-- delete card btn -->
                    <div class="position-absolute d-flex top-0 w-100 px-2 px-lg-3 justify-content-end">
                        <div class="p-3">
                            <div matRipple [matMenuTriggerFor]="deleteManu"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer rounded-3"
                                [class.zx-bg-light]="!isDarkMode">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer" [class.text-red]="!isDarkMode"
                                    [class.text-gray]="isDarkMode">delete_outline</mat-icon>
                            </div>
                        </div>
                        <mat-menu #deleteManu="matMenu">
                            <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                                (click)="onDeleteCreditCard()">
                                <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                    {{ 'my-cc-delete-card-for-good' | translate }}
                                </b>
                                <mat-icon class="text-red m-0 p-0 zx-pt-small flex-shrink-0"
                                    [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                            </button>
                        </mat-menu>
                    </div>
                    <!-- // delete card btn -->
                    <!-- continue with this card -->
                    <div class="position-absolute d-flex bottom-0 w-100 px-2 px-lg-3 justify-content-end">
                        <div class="py-2 px-3 px-lg-2">
                            <button mat-raised-button color="primary" class="text-white rounded-3"
                                style="max-height: 29px;" (click)="backToOrderCCOrderSummary()">
                                {{ "order-summary-continue-with-this-cc" | translate }}
                            </button>
                        </div>
                    </div>
                    <!-- // continue with this card -->
                </article>
            </div>

            <!-- title 2 -->
            <h4 class="pb-0 pt-2 px-1 m-0 d-flex fw-bold"
                *ngIf="user.zCreditInfo?.token && user.zCreditInfo.token !== ''">
                {{ "my-cc-chainge-credit-info" | translate }}
            </h4>

            <!-- explain 2 con -->
            <div class="d-flex flex-column justify-content-lg-between gap-2 gap-lg-0">
                <!-- explain 2 -->
                <span class="px-3 px-lg-4 flex-grow-lg-1">
                    <span *ngIf="user.zCreditInfo?.token && user.zCreditInfo.token !== ''">
                        {{ "my-cc-chainge-credit-info-explain" | translate }}
                    </span>
                    <span *ngIf="!(user.zCreditInfo?.token && user.zCreditInfo.token !== '')">
                        {{ "my-cc-set-credit-info-explain" | translate }}
                    </span>
                </span>

                <div class="zx-required-text-con d-flex justify-content-end">
                    <span class="zx-text-tiny text-green">
                        <b class="zx-text-small">
                            <sup> * </sup>
                        </b>
                        <span class="zx-100-opp">_</span>
                        <span>-</span>
                        <span class="zx-100-opp">_</span>
                        <span>
                            {{ "my-cc-required-exp" | translate }}
                        </span>
                    </span>
                </div>

                <!-- CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM  -->
                <form class="d-flex row pt-lg-2 pt-lg-1 pb-2 pb-lg-0" [formGroup]="creditForm"
                    (submit)="onSaveCreditCard()">

                    <!-- FIELD ================= - Card Number -->
                    <div class="d-flex flex-column gap-2 col-12 col-lg-6 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL"
                            [class.text-red-bold]="isCreditCardFieldsEmphasized && !creditForm.get('cardNum').valid">
                            <span>
                                <b class="zx-text-small text-green">
                                    <sup> * </sup>
                                </b>
                                <span>
                                    {{ "my-cc-card-number" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Number -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-card-number" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="cardNum"
                                [placeholder]="'my-cc-card-number' | translate" required (keypress)="numberOnly($event)"
                                (input)="formatCardNumInput($event)" inputmode="numeric" autocomplete="cc-number">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" [class.text-start]="!isRTL"
                                *ngIf="creditForm.get('cardNum').errors && creditForm.get('cardNum').errors['invalidCreditCard']">
                                {{ "my-cc-card-number.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardNum').value"
                                [class.d-none]="!creditForm.get('cardNum').value">
                                <div matRipple (click)="clearCreditField('cardNum')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Number -->
                    </div>
                    <!-- // ================= FIELD - Card Number -->

                    <!-- FIELD ================= - card validity -->
                    <div class="d-flex flex-column gap-2 col-8 col-lg-4 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL"
                            [class.text-red-bold]="isCreditCardFieldsEmphasized && !creditForm.get('month').valid">
                            <span>
                                <b class="zx-text-small text-green">
                                    <sup> * </sup>
                                </b>
                                <span>
                                    {{ "my-cc-card-validity" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - validity -->
                        <div class="d-flex" [class.flex-row-reverse]="isRTL">
                            <!-- month -->
                            <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1 zx-rounded-start">
                                <mat-label [class.zx-text-white]="isDarkMode">
                                    {{ "my-cc-card-validity.month" | translate }}
                                </mat-label>
                                <input class="text-center" matInput type="text" formControlName="month"
                                    [placeholder]="'MM'" required (keypress)="numberOnly($event)" inputmode="numeric"
                                    autocomplete="cc-exp-month" #monthInput maxlength="2">
                                <div [class.d-none]="!isLoadingUpdates"
                                    class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                    <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                                </div>
                                <mat-error [class.zx-text-white]="isDarkMode" *ngIf="creditForm.get('month').errors"
                                    [class.text-start]="!isRTL">
                                    {{ "my-cc-card-month.error" | translate }}
                                </mat-error>
                            </mat-form-field>
                            <!-- year -->
                            <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1 zx-rounded-end">
                                <mat-label [class.zx-text-white]="isDarkMode">
                                    {{ "my-cc-card-validity.year" | translate }}
                                </mat-label>
                                <input class="text-center" matInput type="text" formControlName="year"
                                    [placeholder]="'YYYY'" required (keypress)="numberOnly($event)" inputmode="numeric"
                                    autocomplete="cc-exp-year" #yearInput (focus)="focusMonthIfEmpty()" maxlength="4">
                                <div [class.d-none]="!isLoadingUpdates"
                                    class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                    <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                                </div>
                                <mat-error [class.zx-text-white]="isDarkMode" *ngIf="creditForm.get('year').errors"
                                    [class.text-start]="!isRTL">
                                    {{ "my-cc-card-year.error" | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- // inner FIELD - validity -->
                    </div>
                    <!-- // FIELD ================= - card validity -->

                    <!-- FIELD ================= - Card CVV -->
                    <div class="d-flex flex-column gap-2 col-4 col-lg-2 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold d-flex gap-2"
                            [class.text-start]="!isRTL">
                            <span
                                [class.text-red-bold]="isCreditCardFieldsEmphasized && !creditForm.get('cardCvv').valid">
                                <b class="zx-text-small text-green">
                                    <sup> * </sup>
                                </b>
                                <span>CVV</span>
                                <span>:</span>
                            </span>
                            <div aria-label="CVV Explained" [matTooltip]="'my-cc-card-cvv-explain' | translate"
                                [matTooltipPosition]="'above'" [dir]="tooltipDirection" [matTooltipShowDelay]="0"
                                class="i-explain-icon svg c-pointer zx-small-icon-size p-1 m-0" style="background-image: url('/assets/images/i-explain-icon.svg');
                                                                                                       background-repeat: no-repeat;
                                                                                                       background-size: cover;
                                                                                                       width: 24px;
                                                                                                       height: 24px;"
                                (click)="toggleTooltip()">
                            </div>
                        </span>
                        <!-- inner FIELD - Card CVV -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">CVV</mat-label>
                            <input matInput type="text" formControlName="cardCvv" [placeholder]="'CVV'" required
                                (keypress)="numberOnly($event)" inputmode="numeric" autocomplete="cc-csc">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" *ngIf="creditForm.get('cardCvv').errors"
                                [class.text-start]="!isRTL">
                                {{ "my-cc-card-cvv.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardCvv').value"
                                [class.d-none]="!creditForm.get('cardCvv').value">
                                <div matRipple (click)="clearCreditField('cardCvv')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card CVV -->
                    </div>
                    <!-- // ================= FIELD - Card CVV -->

                    <!-- FIELD ================= - Card Holder Name -->
                    <div class="d-flex flex-column gap-2 col-12 col-lg-6 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL"
                            [class.text-red-bold]="isCreditCardFieldsEmphasized && !creditForm.get('cardHolderName').valid">
                            <span>
                                <b class="zx-text-small text-green">
                                    <sup> * </sup>
                                </b>
                                <span>
                                    {{ "my-cc-card-holder-name" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Holder Name -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-card-holder-name" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="cardHolderName"
                                [placeholder]="'my-cc-card-holder-name' | translate" required>
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" [class.text-start]="!isRTL"
                                *ngIf="creditForm.get('cardHolderName').errors">
                                {{ "my-cc-card-holder-name.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardHolderName').value"
                                [class.d-none]="!creditForm.get('cardHolderName').value">
                                <div matRipple (click)="clearCreditField('cardHolderName')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Holder Name -->
                    </div>
                    <!-- // ================= FIELD - Card Holder Name -->

                    <!-- FIELD ================= - Card Holder ID -->
                    <div class="d-flex flex-column gap-2 col-12 col-lg-6 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL"
                            [class.text-red-bold]="isCreditCardFieldsEmphasized && !creditForm.get('cardHolderID').valid">
                            <span>
                                <b class="zx-text-small text-green">
                                    <sup> * </sup>
                                </b>
                                <span>
                                    {{ "my-cc-card-holder-id" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Holder ID -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-card-holder-id" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="cardHolderID"
                                [placeholder]="'my-cc-card-holder-id' | translate" required
                                (keypress)="numberOnly($event)" inputmode="numeric">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" *ngIf="creditForm.get('cardHolderID').errors"
                                [class.text-start]="!isRTL">
                                {{ "my-cc-card-holder-id.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardHolderID').value"
                                [class.d-none]="!creditForm.get('cardHolderID').value">
                                <div matRipple (click)="clearCreditField('cardHolderID')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Holder ID -->
                    </div>
                    <!-- // ================= FIELD - Card Holder ID -->

                    <!-- FIELD ================= - Card Billing Email -->
                    <div class="d-flex flex-column gap-2 col-12 col-lg-6 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL">
                            <span>
                                <span>
                                    {{ "my-cc-billing-email" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Billing Email -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-billing-email" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="billingEmail"
                                [placeholder]="'my-cc-billing-email' | translate">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" *ngIf="creditForm.get('billingEmail').errors"
                                [class.text-start]="!isRTL">
                                {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('billingEmail').value"
                                [class.d-none]="!creditForm.get('billingEmail').value">
                                <div matRipple (click)="clearCreditField('billingEmail')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Billing Email -->
                    </div>
                    <!-- // ================= FIELD - Card Billing Email -->

                    <!-- FIELD ================= - Card Customer Name -->
                    <div class="d-flex flex-column gap-2 col-12 col-lg-6 pt-lg-2" [class.col-sm-8]="!isCompanyID"
                        [class.col-sm-6]="isCompanyID">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL">
                            <span>
                                <span>
                                    {{ "my-cc-card-customer-name" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Customer Name -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-card-customer-name" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="cardCustomerName"
                                [placeholder]="'my-cc-card-customer-name' | translate">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" [class.text-start]="!isRTL"
                                *ngIf="creditForm.get('cardCustomerName').errors">
                                {{ "my-cc-card-customer-name.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardCustomerName').value"
                                [class.d-none]="!creditForm.get('cardCustomerName').value">
                                <div matRipple (click)="clearCreditField('cardCustomerName')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Customer Name -->
                    </div>
                    <!-- // ================= FIELD - Card Customer Name -->

                    <!-- BTN ================= - Card Company ID - add -->
                    <div *ngIf="!isCompanyID" class="d-flex px-3 col-12 col-sm-4 col-lg-6 justify-content-center">
                        <button type="button" mat-button color="primary" class="px-2 py-1 rounded-3"
                            (click)="toggleCompanyID()">
                            <div class="d-flex align-items-center gap-1 gap-sm-2">
                                <span class="zx-text-tiny d-flex">
                                    {{ "my-cc-card-company-id-add" | translate }}
                                </span>
                                <mat-icon
                                    class="zx-text-medium d-flex zx-small-tiny-plus-icon-size">add_circle_outline</mat-icon>
                            </div>
                        </button>
                    </div>
                    <!-- // BTN ================= - Card Company ID - add -->

                    <!-- FIELD ================= - Card Company ID -->
                    <div [class.d-none]="!isCompanyID" [class.d-flex]="isCompanyID"
                        class="flex-column gap-2 col-12 col-sm-6 pt-lg-2">
                        <span class="zx-text-tiny zx-text-sm-medium zx-fw-sm-not-bold" [class.text-start]="!isRTL">
                            <span>
                                <span>
                                    {{ "my-cc-card-company-id" | translate }}
                                </span>
                                <span>:</span>
                            </span>
                        </span>
                        <!-- inner FIELD - Card Company ID -->
                        <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1">
                            <mat-label [class.zx-text-white]="isDarkMode">
                                {{ "my-cc-card-company-id" | translate }}
                            </mat-label>
                            <input matInput type="text" formControlName="cardCompanyID"
                                [placeholder]="'my-cc-card-company-id' | translate" (keypress)="numberOnly($event)"
                                inputmode="numeric">
                            <div [class.d-none]="!isLoadingUpdates"
                                class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                                <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                            </div>
                            <mat-error [class.zx-text-white]="isDarkMode" [class.text-start]="!isRTL"
                                *ngIf="creditForm.get('cardCompanyID').errors">
                                {{ "my-cc-card-company-id.error" | translate }}
                            </mat-error>
                            <!-- clear field -->
                            <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                                [class.top-clear-field-not-rtl]="!isRTL"
                                [class.d-flex]="creditForm.get('cardCompanyID').value"
                                [class.d-none]="!creditForm.get('cardCompanyID').value">
                                <div matRipple (click)="clearCreditField('cardCompanyID')"
                                    class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                    <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                        [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                                </div>
                            </div>
                            <!-- // clear field -->
                        </mat-form-field>
                        <!-- // inner FIELD - Card Company ID -->
                    </div>
                    <!-- // ================= FIELD - Card Company ID -->

                    <!-- BTN ================= - Card Company ID - remove -->
                    <div *ngIf="isCompanyID" class="d-none d-sm-flex d-lg-none col-6"></div>
                    <div *ngIf="isCompanyID"
                        class="d-flex px-3 col-12 col-sm-6 justify-content-center zx-transform-Company-id-btn">
                        <button class="px-2 py-1 rounded-3" type="button" mat-button color="primary"
                            (click)="toggleCompanyID()">
                            <div class="d-flex align-items-center gap-1 gap-sm-2">
                                <span class="zx-text-tiny d-flex">
                                    {{ "my-cc-card-company-id-renove" | translate }}
                                </span>
                                <mat-icon
                                    class="zx-text-medium d-flex zx-small-tiny-plus-icon-size">highlight_off</mat-icon>
                            </div>
                        </button>
                    </div>
                    <!-- // BTN ================= - Card Company ID - remove -->

                </form>
                <!-- // CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM ============ CREDIT FORM  -->

            </div>
            <!-- // explain 2 con -->

            <span *ngIf="!isCompanyID" class="spacer w-100"></span>

            <!-- BTN ================= - Card SAVE BTN -->
            <div (click)="emphasizeCreditCardFields()"
                class="d-flex flex-column p-3 pb-5 pb-sm-2 pb-lg-1 col-12 justify-content-center w-100">
                <button [disabled]="!(creditForm.get('cardNum').valid &&
                                  creditForm.get('month').valid &&
                                  creditForm.get('year').valid &&
                                  creditForm.get('cardCvv').valid &&
                                  creditForm.get('cardHolderName').valid &&
                                  creditForm.get('cardHolderID').valid)"
                    class="text-white rounded-pill w-100 zx-small-btn" type="button" mat-raised-button color="primary"
                    (click)="onSaveCreditCard()">
                    {{ ('order-summary-confirm-card-info' + ((phPaymentForOrder || emptyPaymentForOrder) ? '.and-payment' : (isPH ? '.and-print' : ''))) | translate }}
                </button>
                <span *ngIf="isIphone()" style="height: 80px;"></span>
            </div>
            <!-- // BTN ================= - Card SAVE BTN -->

        </div>

    </div>
    <!-- // CC EDIT! ===================================== CC EDIT! ===================================== CC EDIT!  -->















    <!-- AFTER SENDING ORDER! ===================================== AFTER SENDING ORDER! ===================================== AFTER SENDING ORDER!  -->
    <div *ngIf="isLoading || isOrderPrinted || isOrderSaved" [class.zx-text-white]="isDarkMode"
        class="order-summary-after-send d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-1 gap-md-3 w-100 position-relative"
        [class.zx-ltr]="!isRTL" [class.zx-transition-orders-con]="isLottieStart && !isLottieEnd">

        <div *ngIf="isLoading"
            class="d-flex w-100 flex-grow-1 flex-column gap-3 justify-content-center align-items-center">
            <mat-spinner *ngIf="!isLottieStart && !isTooManyCvvTry"
                class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
            <span class="opacity-trans" *ngIf="(phPaymentForOrder || emptyPaymentForOrder) && isLoading">{{ (isAdminOrder ? 'order-summary-loading-text.ph-payment-admin-order' : 'order-summary-loading-text.ph-payment') | translate }}</span>
            <span class="opacity-trans" *ngIf="((!phPaymentForOrder && !emptyPaymentForOrder) || !isLoading) && isLoadingText !== ''">
                {{ "order-summary-loading-text." + isLoadingText | translate }}
            </span>
            <b *ngIf="isTooManyCvvTry" class="zx-text-medium text-center w-100" [class.text-red]="!isDarkMode">
                {{ "my-cc-card-cvv.too-many-try" | translate }}
            </b>
        </div>

        <div *ngIf="!isLoading && (isOrderPrinted || isOrderSaved)"
            class="w-100 d-flex justify-content-center align-items-end position-absolute order-summary-confetti-layer"
            style="opacity: 22%;">
            <div id="animationConfettiContainer"></div>
        </div>

        <!-- WALL PROMO SUCCESS -->
        <div *ngIf="!isLoading && (isOrderPrinted || isOrderSaved) && shouldShowWallPromo()"
            class="order-wall-promo d-flex flex-column w-100 flex-grow-1 align-items-stretch"
            [class.order-wall-promo-ltr]="!isRTL"
            [class.order-wall-promo-on-dark]="isDarkMode">

            <!-- Regular completion texts (above wall promo) -->
            <div class="order-wall-promo-regular d-flex flex-column align-items-center gap-2 w-100">
                <h4 class="order-wall-promo-success-title text-center fw-bold mb-0">
                    <span *ngIf="isOrderPrinted">
                        <span *ngIf="printingService === 'plotter'">
                            <span>{{ 'order-complited.printed.plotter.title-1' | translate }}</span>
                            <span> {{ "choose-branch.naming." + branchName | translate }}</span>
                            <span>{{ 'order-complited.printed.plotter.title-2' | translate }}</span>
                        </span>
                        <span *ngIf="printingService === 'express'">
                            <span>{{ 'order-complited.printed.express.title-1' | translate }}</span>
                            <span> {{ "choose-branch.naming." + branchName | translate }}</span>
                            <span>{{ 'order-complited.printed.express.title-2' | translate }}</span>
                        </span>
                        <span *ngIf="printingService === 'ph' && !isPhPaymentSuccess && !isEmptyPaymentSuccess">
                            {{ 'order-complited.printed.ph.title' | translate }}
                        </span>
                        <span *ngIf="isPhPaymentSuccess || isEmptyPaymentSuccess">
                            {{ 'order-complited.payment-success.title' | translate }}
                        </span>
                    </span>
                    <span *ngIf="isOrderSaved">
                        {{ 'order-complited.saved.title' | translate }}
                    </span>
                </h4>

                <b *ngIf="isOrderPrinted" class="order-wall-promo-order-info text-center text-green">
                    <span *ngIf="isPhPaymentSuccess || isEmptyPaymentSuccess">{{ 'order-complited.payment-success.title.sub' | translate }}</span>
                    <span *ngIf="!isPhPaymentSuccess && !isEmptyPaymentSuccess && printingService === 'ph'">{{ 'order-complited.printed.ph.title.sub' | translate }}</span>
                    <span *ngIf="!isPhPaymentSuccess && !isEmptyPaymentSuccess && printingService !== 'ph'">{{ 'order-complited.printed.title.sub' | translate }}</span>
                </b>

                <b *ngIf="isOrderSaved" class="order-wall-promo-order-info text-center text-green">
                    {{ 'order-complited.saved.title.sub' | translate }}
                </b>
                <button *ngIf="isOrderSaved && !isPendingOrder" type="button" mat-button
                    class="order-wall-promo-copy-link rounded-pill"
                    (click)="copyOrderLink()">
                    <span class="d-inline-flex align-items-center gap-1">
                        <mat-icon class="zx-text-small text-green zx-small-tiny-plus-icon-size opacity-75">content_copy</mat-icon>
                        <span class="zx-text-tiny opacity-75 text-green">
                            {{ 'order-summary.copy-link' | translate }}
                        </span>
                    </span>
                </button>
            </div>

            <!-- Wall promo block -->
            <div class="order-wall-promo-hero d-flex flex-column flex-md-row align-items-center gap-3 gap-md-4 w-100">
                <img class="order-wall-promo-image"
                    src="assets/images/wallImage.png"
                    [attr.alt]="'order-complited.wall.title' | translate">
                <div class="order-wall-promo-hero-text d-flex flex-column gap-2 flex-grow-1">
                    <h4 class="order-wall-promo-title fw-bold mb-0">
                        {{ 'order-complited.wall.title' | translate }}
                    </h4>
                    <p class="order-wall-promo-subtitle mb-0 opacity-75">
                        {{ 'order-complited.wall.subtitle' | translate }}
                    </p>
                </div>
            </div>

            <div class="order-wall-promo-features">
                <div class="order-wall-promo-feature">
                    <div class="order-wall-promo-feature-icon order-wall-promo-feature-icon-exposure">
                        <mat-icon>visibility</mat-icon>
                    </div>
                    <b class="order-wall-promo-feature-title">{{ 'order-complited.wall.feature.exposure.title' | translate }}</b>
                    <span class="order-wall-promo-feature-text">{{ 'order-complited.wall.feature.exposure.text' | translate }}</span>
                </div>
                <div class="order-wall-promo-feature">
                    <div class="order-wall-promo-feature-icon order-wall-promo-feature-icon-likes">
                        <mat-icon>favorite</mat-icon>
                    </div>
                    <b class="order-wall-promo-feature-title">{{ 'order-complited.wall.feature.likes.title' | translate }}</b>
                    <span class="order-wall-promo-feature-text">{{ 'order-complited.wall.feature.likes.text' | translate }}</span>
                </div>
                <div class="order-wall-promo-feature">
                    <div class="order-wall-promo-feature-icon order-wall-promo-feature-icon-jobs">
                        <mat-icon>work</mat-icon>
                    </div>
                    <b class="order-wall-promo-feature-title">{{ 'order-complited.wall.feature.jobs.title' | translate }}</b>
                    <span class="order-wall-promo-feature-text">{{ 'order-complited.wall.feature.jobs.text' | translate }}</span>
                </div>
                <div class="order-wall-promo-feature">
                    <div class="order-wall-promo-feature-icon order-wall-promo-feature-icon-help">
                        <mat-icon>groups</mat-icon>
                    </div>
                    <b class="order-wall-promo-feature-title">{{ 'order-complited.wall.feature.help.title' | translate }}</b>
                    <span class="order-wall-promo-feature-text">{{ 'order-complited.wall.feature.help.text' | translate }}</span>
                </div>
            </div>

            <div class="order-wall-promo-buttons d-flex flex-column flex-md-row align-items-stretch justify-content-center gap-2 w-100"
                [class.flex-md-row-reverse]="!isRTL">
                <button type="button" color="primary" mat-raised-button
                    class="order-wall-promo-primary-btn text-white rounded-pill fw-bold"
                    (click)="openPersonalWall()">
                    <span class="d-inline-flex align-items-center gap-2">
                        <mat-icon class="order-wall-promo-primary-icon">auto_awesome</mat-icon>
                        <span class="order-wall-promo-primary-label">{{ 'order-complited.wall.open-wall' | translate }}</span>
                    </span>
                </button>
                <button type="button" mat-button class="rounded-pill text-green order-wall-promo-nav-btn"
                    (click)="openRightPlaceDialog()">
                    <b>{{ "main-nav.new-order" | translate }}</b>
                </button>
                <button *ngIf="isOrderPrinted && printingService === 'plotter'" type="button" mat-button
                    class="rounded-pill text-green order-wall-promo-nav-btn"
                    (click)="goToPrintingQueue()">
                    <b class="d-sm-none">{{ "order-complited.printed.view-que.short" | translate }}</b>
                    <b class="d-none d-sm-inline">{{ "order-complited.printed.view-que" | translate }}</b>
                </button>
                <button *ngIf="isOrderSaved" type="button" mat-button
                    class="rounded-pill text-green order-wall-promo-nav-btn"
                    (click)="goToMyOrders()">
                    <b class="d-sm-none">{{ "order-complited.printed.view-my-orders.short" | translate }}</b>
                    <b class="d-none d-sm-inline">{{ "order-complited.printed.view-my-orders" | translate }}</b>
                </button>
            </div>
        </div>
        <!-- // WALL PROMO SUCCESS -->

        <div *ngIf="!isLoading && (isOrderPrinted || isOrderSaved) && !shouldShowWallPromo()"
            class="d-flex flex-column w-100 flex-grow-1 align-items-center position-relative"
            style="z-index: 1;">

            <!-- complited high title -->
            <b *ngIf="isOrderPrinted" class="pt-lg-2 text-center text-green zx-text-medium opacity-75">
                {{ 'order-complited.thanks-for-printing' | translate }}
            </b>
            <!-- // complited high title -->

            <!-- complited IMG -->
            <img class="zx-big-icon-size zx-huge-icon-size-lg mb-1 mb-lg-4 object-fit-contain"
                src="assets/images/positive-sent-icon.svg" alt="Order Sent Successfully Icon">
            <!-- // complited IMG -->

            <!-- main texts -->
            <div style="max-width: 710px;"
                class="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 gap-2">
                <!-- title -->
                <h4 class="text-center fw-bold zx-lh-h3">
                    <span *ngIf="isOrderPrinted">
                        <span *ngIf="printingService === 'plotter'">
                            <span>
                                {{ 'order-complited.printed.plotter.title-1' | translate }}
                            </span>
                            <span>
                                {{ "choose-branch.naming." + branchName | translate }}
                            </span>
                            <span>
                                {{ 'order-complited.printed.plotter.title-2' | translate }}
                            </span>
                        </span>
                        <span *ngIf="printingService === 'express'">
                            <span>
                                {{ 'order-complited.printed.express.title-1' | translate }}
                            </span>
                            <span>
                                {{ "choose-branch.naming." + branchName | translate }}
                            </span>
                            <span>
                                {{ 'order-complited.printed.express.title-2' | translate }}
                            </span>
                        </span>
                        <span *ngIf="printingService === 'ph' && !isPhPaymentSuccess && !isEmptyPaymentSuccess">
                            {{ 'order-complited.printed.ph.title' | translate }}
                        </span>
                        <span *ngIf="isPhPaymentSuccess || isEmptyPaymentSuccess">
                            {{ 'order-complited.payment-success.title' | translate }}
                        </span>
                    </span>
                    <span *ngIf="isOrderSaved">
                        {{ 'order-complited.saved.title' | translate }}
                    </span>
                </h4>
                <!-- // title -->
                <b *ngIf="isOrderPrinted" class="text-center text-green zx-text-medium zx-text-sm-big">
                    <span *ngIf="isPhPaymentSuccess || isEmptyPaymentSuccess">{{ 'order-complited.payment-success.title.sub' | translate }}</span>
                    <span *ngIf="!isPhPaymentSuccess && !isEmptyPaymentSuccess && printingService === 'ph'">{{ 'order-complited.printed.ph.title.sub' | translate }}</span>
                    <span *ngIf="!isPhPaymentSuccess && !isEmptyPaymentSuccess && printingService !== 'ph'">{{ 'order-complited.printed.title.sub' | translate }}</span>
                </b>
                <!-- PRINTED -->
                <div *ngIf="isOrderPrinted"
                    class="d-flex flex-column justify-content-center flex-grow-1 align-items-center w-100 px-lg-3 gap-1 gap-lg-2">
                    <div
                        class="w-100 d-flex gap-2 pag-lg-3 align-items-center justify-content-center zx-text-tiny zx-text-sm-small text-gray">
                        <b class="px-2 py-1 rounded-3 zx-bg-gray-v-light-opacity">
                            <span *ngIf="is3D">{{ 'order-complited.printed.ph.problme-1' | translate }}</span>
                            <span *ngIf="!is3D">{{ 'order-complited.printed.title.sub.problme-1' | translate }}</span>
                        </b>
                        <b class="px-2 py-1 rounded-3 zx-bg-gray-v-light-opacity">
                            <span *ngIf="is3D">{{ 'order-complited.printed.ph.problme-2' | translate }}</span>
                            <span *ngIf="!is3D">{{ 'order-complited.printed.title.sub.problme-2' | translate }}</span>
                        </b>
                    </div>
                    <b *ngIf="!is3D" class="zx-text-medium zx-text-sm-big zx-text-whatsup">
                        {{ 'order-complited.printed.title.sub.problme-3' | translate }}
                    </b>
                    <button *ngIf="is3D" mat-button (click)="goToOrderChat()"
                        class="rounded-pill text-green px-3 order-summary-ph-chat-btn">
                        <div class="d-flex align-items-center gap-2 justify-content-center">
                            <mat-icon class="zx-text-small text-green order-summary-ph-chat-icon">chat</mat-icon>
                            <b class="zx-text-small">{{ "ph-order-action.chat-with-machine-operator" | translate }}</b>
                        </div>
                    </button>
                    <button *ngIf="!is3D" mat-raised-button (click)="openWhatsApp()"
                        class="rounded-pill zx-text-tiny zx-text-sm-small">
                        <div class="w-100 h-100 d-flex align-items-center gap-2">
                            <div class="whatsup-logo-container-small">
                                <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
                            </div>
                            <span class="zx-text-small zx-text-whatsup">
                                {{ 'order-complited.printed.title.sub.problme-btn' | translate }}
                            </span>
                        </div>
                    </button>
                </div>
                <!-- // PRINTED -->

                <!-- SAVED -->
                <div *ngIf="isOrderSaved" class="d-flex flex-column flex-grow-1 align-items-center w-100 px-lg-3 gap-3">
                    <b class="text-center text-green zx-text-medium zx-text-sm-big">
                        {{ 'order-complited.saved.title.sub' | translate }}
                    </b>
                    <span *ngIf="!isPendingOrder" class="d-flex w-100 justify-content-center p-0 m-0">
                        <button mat-button class="rounded-pill" (click)="copyOrderLink()">
                            <div class="d-flex align-items-center gap-1 gap-md-2 pt-1 px-2 px-lg-3">
                                <mat-icon
                                    class="zx-text-small text-green c-pointer zx-small-tiny-plus-icon-size opacity-75">content_copy</mat-icon>
                                <span class="zx-text-tiny opacity-75 pb-1 text-green">
                                    {{ 'order-summary.copy-link' | translate }}
                                </span>
                            </div>
                        </button>
                    </span>
                    <span class="text-center">
                        <span>
                            {{ 'order-complited.saved.title.sub.exp-1' | translate }}
                        </span>
                        <b>
                            {{ "choose-branch.naming." + branchName | translate }}
                        </b>
                        <span>
                            {{ 'order-complited.saved.title.sub.exp-2' | translate }}
                        </span>
                    </span>
                </div>

                <!-- // SAVED -->

            </div>
            <!-- // main texts -->

            <!-- files and price TOTAL line -->
            <div class="d-flex flex-column flex-lg-row justify-content-center align-items-end w-100 gap-3 gap-lg-4 pt-1"
                [class.flex-row-reverse]="!isRTL">
                <!-- 3D – צור הזמנה חדשה + מעקב אחר סטטוס (חצי חצי בדסקטופ) -->
                <div *ngIf="isOrderPrinted && is3D" class="d-flex flex-column flex-lg-row gap-3 w-100">
                    <button color="primary" mat-raised-button class="text-white rounded-pill fw-bold flex-grow-1"
                        (click)="openRightPlaceDialog()">
                        {{ "main-nav.new-order" | translate }}
                    </button>
                    <button mat-button class="rounded-pill text-green flex-grow-1" (click)="goToOrderChat()">
                        <b class="text-center w-100">{{ "collect.order-track" | translate }}</b>
                    </button>
                </div>
                <!-- לא 3D – כפתורים רגילים -->
                <ng-container *ngIf="!(isOrderPrinted && is3D)">
                <button color="primary" mat-raised-button class="text-white rounded-pill w-100 fw-bold"
                    (click)="openRightPlaceDialog()">
                    {{ "main-nav.new-order" | translate }}
                </button>
                <button *ngIf="isOrderPrinted && printingService === 'plotter'" mat-button
                    class="rounded-pill w-100 text-green" (click)="goToPrintingQueue()">
                    <b class="d-sm-none text-center">
                        {{ "order-complited.printed.view-que.short" | translate }}
                    </b>
                    <b class="d-none d-sm-flex text-center justify-content-center">
                        {{ "order-complited.printed.view-que" | translate }}
                    </b>
                </button>
                <button *ngIf="isOrderSaved" mat-button class="rounded-pill w-100 text-green justify-content-center"
                    (click)="goToMyOrders()">
                    <b class="d-flex d-sm-none justify-content-center">
                        {{ "order-complited.printed.view-my-orders.short" | translate }}
                    </b>
                    <b class="d-none d-sm-flex justify-content-center">
                        {{ "order-complited.printed.view-my-orders" | translate }}
                    </b>
                </button>
                </ng-container>
            </div>
            <!-- // files and price TOTAL line -->

        </div>

    </div>
    <!-- // AFTER SENDING ORDER! ===================================== AFTER SENDING ORDER! ===================================== AFTER SENDING ORDER!  -->

    <!-- סטריפ קידום הדפסת תלת מימד – שלב הצלחה, פלוטר/אקספרס בלבד -->
    <div *ngIf="!isLoading && (isOrderPrinted || isOrderSaved) && !shouldShowWallPromo() && (printingService === 'plotter' || printingService === 'express')"
        class="order-summary-new-3d-badge-corner"
        [class.order-summary-new-3d-badge-corner-left]="!isRTL">
        <button type="button"
            class="order-summary-new-3d-badge-hit"
            [attr.aria-label]="'order-summary.new-3d-print-service-line1' | translate"
            (click)="navigateTo3DTechnologySelection()">
            <span class="order-summary-new-3d-badge" [class.order-summary-new-3d-badge-left]="!isRTL">
                <span class="order-summary-new-3d-badge-text">
                    <span>{{ 'order-summary.new-3d-print-service-line1' | translate }}</span>
                    <span>{{ 'order-summary.new-3d-print-service-line2' | translate }}</span>
                </span>
            </span>
        </button>
    </div>

</div>